/* Generated static About copy. Keep aligned with localization/locales.json. */
export const ABOUT_TRANSLATIONS: Record<string, Record<string, string>> = {
  en: {
    'about.eyebrow': 'Measured with care. Explained with context.',
    'about.title': 'A clearer view of cognitive strengths',
    'about.lede':
      'Complete an adaptive assessment across abstract, numerical, verbal, and spatial reasoning. Results are estimates with a confidence range - not a diagnosis or a final verdict about a person.',
    'about.startTest': 'Start the free 40-question test',
    'about.testNote': 'A new balanced question set is drawn for every attempt.',
    'about.safeguard': 'Recruitment safeguard',
    'about.decision': 'One source of information - not a hiring decision',
    'about.decisionText':
      'Employers must combine results with structured interviews, relevant experience, and human review. The platform does not label candidates as hire or reject.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  fr: {
    'about.eyebrow': 'Mesurées avec soin. Expliquées dans leur contexte.',
    'about.title': 'Une vision plus claire des forces cognitives',
    'about.lede':
      'Les résultats sont des estimations avec une fourchette de confiance, et non un diagnostic ou un verdict final sur une personne, mais un ensemble de critères qui vous aideront à déterminer si vous êtes capable de comprendre et de comprendre les autres.',
    'about.startTest': 'Démarrer le free 40-question test',
    'about.testNote':
      'Un nouveau jeu de questions équilibrées est tiré au sort pour chaque tentative.',
    'about.safeguard': 'Garde-fou de recrutement',
    'about.decision': 'Une source d\u0027information unique - pas une décision d\u0027embauche',
    'about.decisionText':
      'Les employeurs doivent combiner les résultats avec des entrevues structurées, une expérience pertinente et un examen humain.La plateforme n’étiquette pas les candidats comme embauché ou rejeté.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  de: {
    'about.eyebrow': 'Mit Sorgfalt gemessen. Mit Kontext erklärt.',
    'about.title': 'Ein klareres Bild der kognitiven Stärken',
    'about.lede':
      'Die Ergebnisse sind Schätzungen mit einem Konfidenzbereich, keine Diagnose oder ein endgültiges Urteil über eine Person, sondern eine Bewertung der Fähigkeiten, die Sie in der Praxis erleben.',
    'about.startTest': 'Start the free 40- Fragen-Test',
    'about.testNote': 'Für jeden Versuch wird ein neuer ausgewogener Fragensatz gezogen.',
    'about.safeguard': 'Recruitment-Schutzmaßnahme',
    'about.decision': 'Eine Informationsquelle - keine Einstellungsentscheidung',
    'about.decisionText':
      'Arbeitgeber müssen die Ergebnisse mit strukturierten Interviews, relevanter Erfahrung und einer menschlichen Überprüfung kombinieren, um die Bewerber zu finden, die sie brauchen.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  nl: {
    'about.eyebrow': 'Met zorg gemeten. Uitgelegd in context.',
    'about.title': 'Een duidelijker beeld van cognitieve krachten',
    'about.lede':
      'De resultaten zijn schattingen met een betrouwbaarheidsbereik - geen diagnose of een definitief oordeel over een persoon - maar een indicatie van de mate waarin de persoon in staat is om te denken, te communiceren en te communiceren.',
    'about.startTest': 'Start de gratis 40- vraag test',
    'about.testNote': 'Voor elke poging wordt een nieuwe gebalanceerde vragenset getrokken.',
    'about.safeguard': 'Recruitment safeguard',
    'about.decision': 'Eén bron van informatie - geen beslissing over aanwerving',
    'about.decisionText':
      'Werkgevers moeten de resultaten van gestructureerde interviews, relevante ervaring en menselijke beoordeling combineren om de juiste kandidaat te vinden.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  lb: {
    'about.eyebrow': 'D\u0027Sprooch ass am Kontext vun der Konscht ervirgehuewen.',
    'about.title': 'Si ass eng vun de wichtegste kognitiven Fäegkeeten.',
    'about.lede':
      'Compléit eng adaptiv Bewäertung iwwer abstrakt, numerisch, verbal a räumlech Argumentatioun. Resultater sinn Schätzungen mat engem Vertrauensberäich - keng Diagnos oder e definitivt Uerteel iwwer eng Persoun.',
    'about.startTest': 'Start the free 40-question test',
    'about.testNote': 'Et gëtt eng ganz Rei vu verschiddene Methoden fir ze testen.',
    'about.safeguard': 'Rekrutementsgesetz',
    'about.decision': 'Informatiounen Nothing to Lose ass e lëtzebuergesche Film.',
    'about.decisionText':
      'D\u0027Arbechtgeber mussen d\u0027Resultater mat strukturéierte Interviewen, relevanter Erfahrung a Mënschekontroll kombinéieren. D\u0027Plattform markéiert keng Kandidaten als hire oder refuséieren.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  es: {
    'about.eyebrow': 'Medido con cuidado. Explicado con contexto.',
    'about.title': 'Una visión más clara de las fortalezas cognitivas',
    'about.lede':
      'Los resultados son estimaciones con un rango de confianza, no un diagnóstico o un veredicto final sobre una persona, y se pueden usar para evaluar el rendimiento de una persona en un contexto de aprendizaje.',
    'about.startTest': 'Comience el juego gratis 40-pregunta de prueba',
    'about.testNote': 'Se sortea un nuevo conjunto de preguntas equilibradas para cada intento.',
    'about.safeguard': 'Salvaguardia de contratación',
    'about.decision': 'Una fuente de información - no una decisión de contratación',
    'about.decisionText':
      'Los empleadores deben combinar los resultados con entrevistas estructuradas, experiencia relevante y revisión humana, y la plataforma no etiqueta a los candidatos como contratados o rechazados.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  pt: {
    'about.eyebrow': 'Medido com cuidado. Explicado com contexto.',
    'about.title': 'Uma visão mais clara dos pontos fortes cognitivos',
    'about.lede':
      'Os resultados são estimativas com um intervalo de confiança - não um diagnóstico ou um veredicto final sobre uma pessoa, mas sim uma avaliação de sua capacidade de raciocínio abstrato, numérico, verbal e espacial.',
    'about.startTest': 'Comece o jogo grátis 40-question teste',
    'about.testNote': 'Um novo conjunto de perguntas equilibradas é sorteado para cada tentativa.',
    'about.safeguard': 'Salvaguarda de recrutamento',
    'about.decision': 'Uma fonte de informação - não uma decisão de contratação',
    'about.decisionText':
      'Os empregadores devem combinar os resultados com entrevistas estruturadas, experiência relevante e revisão humana, e a plataforma não classifica os candidatos como contratados ou rejeitados.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  it: {
    'about.eyebrow': 'Misurato con cura. Spiegato con il contesto.',
    'about.title': 'Una visione più chiara dei punti di forza cognitivi',
    'about.lede':
      'Completa una valutazione adattativa del ragionamento astratto, numerico, verbale e spaziale.I risultati sono stime con un intervallo di confidenza, non una diagnosi o un verdetto finale su una persona.',
    'about.startTest': 'Inizia il free 40-question test',
    'about.testNote': 'Per ogni tentativo viene estratto un nuovo set di domande bilanciate.',
    'about.safeguard': 'Garanzia di assunzione',
    'about.decision': 'Una fonte di informazioni - non una decisione di assunzione',
    'about.decisionText':
      'I datori di lavoro devono combinare i risultati con colloqui strutturati, esperienze rilevanti e una revisione umana.La piattaforma non etichetta i candidati come assunti o rifiutati.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  el: {
    'about.eyebrow': 'Μετρήθηκε με προσοχή. Εξηγήθηκε με το πλαίσιο.',
    'about.title': 'Μια σαφέστερη εικόνα των γνωστικών δυνάμεων',
    'about.lede':
      'Ολοκληρώστε μια προσαρμοστική αξιολόγηση σε αφηρημένη, αριθμητική, λεκτική και χωρική συλλογιστική.Τα αποτελέσματα είναι εκτιμήσεις με ένα εύρος εμπιστοσύνης - όχι μια διάγνωση ή μια τελική ετυμηγορία για ένα άτομο.',
    'about.startTest': 'Ξεκινήστε το δωρεάν 2016 40- ερώτηση δοκιμής',
    'about.testNote': 'Για κάθε προσπάθεια, κληρώνεται ένα νέο ισορροπημένο σύνολο ερωτήσεων.',
    'about.safeguard': 'Διασφάλιση πρόσληψης',
    'about.decision': 'Μία πηγή πληροφοριών - όχι μια απόφαση πρόσληψης',
    'about.decisionText':
      'Οι εργοδότες πρέπει να συνδυάζουν τα αποτελέσματα με δομημένες συνεντεύξεις, σχετική εμπειρία και ανθρώπινη αξιολόγηση.Η πλατφόρμα δεν ονομάζει τους υποψηφίους ως πρόσληψη ή απόρριψη.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  mt: {
    'about.eyebrow': 'Imkejla b\u0027attenzjoni. Spjegati bil-kuntest.',
    'about.title': 'Ħsieb aktar ċar tal-qawwa konjittiva',
    'about.lede':
      'Tlesta valutazzjoni adattattiva fuq raġunament astratt, numeriku, verbali u spazjali.Ir-riżultati huma stimi b\u0027firxa ta\u0027 kunfidenza - mhux dijanjosi jew sentenza finali dwar persuna.',
    'about.startTest': 'Ibda l-logħba b\u0027xejn 40-test tal-mistoqsija',
    'about.testNote': 'Għal kull tentattiv jinġibed sett ta’ mistoqsijiet ibbilanċjati ġdid.',
    'about.safeguard': 'Salvagwardja tar-reklutaġġ',
    'about.decision': 'Sors wieħed ta\u0027 informazzjoni - mhux deċiżjoni ta\u0027 reklutaġġ',
    'about.decisionText':
      'Min iħaddem irid jgħaqqad ir-riżultati ma’ intervisti strutturati, esperjenza rilevanti u reviżjoni umana, u ma jistax jiddikjara li kandidati ġew reklutati jew rifjutati.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  da: {
    'about.eyebrow': 'Målt med omhu. Forklaret i sammenhæng.',
    'about.title': 'Et klarere billede af kognitive styrker',
    'about.lede':
      'Gennemfør en adaptiv vurdering på tværs af abstrakt, numerisk, verbal og rumlig ræsonnement.Resultaterne er estimater med et konfidensinterval - ikke en diagnose eller en endelig dom om en person.',
    'about.startTest': 'Start den gratis. 40- Spørgsmål test',
    'about.testNote': 'Der trækkes et nyt afbalanceret spørgsmålssæt for hvert forsøg.',
    'about.safeguard': 'Sikkerhedsforanstaltning ved ansættelse',
    'about.decision': 'Én kilde til information - ikke en ansættelsesbeslutning',
    'about.decisionText':
      'Arbejdsgivere skal kombinere resultaterne med strukturerede interviews, relevant erfaring og en menneskelig gennemgang, og platformen mærker ikke kandidater som ansat eller afvist.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  sv: {
    'about.eyebrow': 'Mätt med omsorg. Förklarat med sammanhang.',
    'about.title': 'En tydligare bild av kognitiva styrkor',
    'about.lede':
      'Resultaten är uppskattningar med ett konfidensintervall – inte en diagnos eller en slutgiltig dom om en person, utan en uppskattning av vad som är möjligt att göra med en persons förmåga att tänka abstrakt, numeriskt, verbalt och rumsligt.',
    'about.startTest': 'Starta den fria 40-fråga test',
    'about.testNote': 'En ny balanserad frågeuppsättning dras för varje försök.',
    'about.safeguard': 'Skyddsåtgärder vid rekrytering',
    'about.decision': 'En informationskälla – inte ett anställningsbeslut',
    'about.decisionText':
      'Arbetsgivare måste kombinera resultaten med strukturerade intervjuer, relevant erfarenhet och mänsklig granskning, och plattformen märker inte kandidater som anställda eller avvisade.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  no: {
    'about.eyebrow': 'Målt med omhu. Forklart med kontekst.',
    'about.title': 'Et klarere bilde av kognitive styrker',
    'about.lede':
      'Resultatene er anslag med et konfidensintervall – ikke en diagnose eller en endelig dom om en person, men en vurdering av hvordan en person kan bruke sine ferdigheter i et bestemt miljø.',
    'about.startTest': 'Start den frie 40-spørsmål test',
    'about.testNote': 'Et nytt balansert spørsmålssett trekkes for hvert forsøk.',
    'about.safeguard': 'Rekrutteringssikkerhet',
    'about.decision': 'Én kilde til informasjon - ikke en ansettelsesbeslutning',
    'about.decisionText':
      'Arbeidsgivere må kombinere resultatene med strukturerte intervjuer, relevant erfaring og menneskelig gjennomgang, og plattformen merker ikke kandidater som ansatt eller avvist.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  fi: {
    'about.eyebrow': 'Huolellisesti mitattu. Selitetty asiayhteyden mukaan.',
    'about.title': 'Selkeämpi näkemys kognitiivisista vahvuuksista',
    'about.lede':
      'Suorita mukautuva arviointi abstraktista, numeerista, verbaalista ja tilallista päättelykykyä varten.Tulokset ovat arvioita, joissa on luottamusväli.Nämä eivät ole diagnooseja tai lopullisia tuomioita henkilöstä.',
    'about.startTest': 'Aloita ilmainen 40-Kysymys testi',
    'about.testNote': 'Jokaista yritystä varten arvotaan uusi tasapainotettu kysymyssarja.',
    'about.safeguard': 'Rekrytointisuoja',
    'about.decision': 'Yksi tietolähde – ei palkkauspäätöstä',
    'about.decisionText':
      'Työnantajien on yhdistettävä tulokset strukturoituihin haastatteluihin, asiaankuuluvaan kokemukseen ja ihmisen tekemään arviointiin, jotta he voivat tehdä oikean päätöksen.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  is: {
    'about.eyebrow': 'Mælt með varúð. Útskýrt með samhengi.',
    'about.title': 'Skýrari mynd af vitrænum styrkleikum',
    'about.lede':
      'Ljúka aðlögunarhæfnimati yfir abstrakt, tölfræðileg, munnleg og staðbundin rökhugsun.Niðurstöður eru áætlanir með öryggisbili - ekki greiningu eða endanlega dómsúrskurði um mann.',
    'about.startTest': 'Byrjaðu frjáls 40-spurning próf',
    'about.testNote': 'Nýtt jafnvægi spurningasett er dregið fyrir hverja tilraun.',
    'about.safeguard': 'Vernd við ráðningu',
    'about.decision': 'Einn uppspretta upplýsinga - ekki ráðningarákvörðun',
    'about.decisionText':
      'Vinnuveitendur verða að sameina niðurstöður með skipulögðum viðtölum, viðeigandi reynslu og mannlegri endurskoðun.Viðskiptavinurinn merkir ekki umsækjendur sem ráða eða hafna.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  pl: {
    'about.eyebrow': 'Mierzone z troską. Wyjaśnione w kontekście.',
    'about.title': 'Bardziej przejrzysty obraz mocnych stron poznawczych',
    'about.lede':
      'Wyniki są szacunkami z zakresem ufności, a nie diagnozą lub ostatecznym werdyktentem na temat osoby.Wyniki są szacunkami z zakresem ufności, a nie diagnozą lub ostatecznym werdyktentem na temat osoby.',
    'about.startTest': 'Start the free 40- pytanie test',
    'about.testNote': 'Dla każdej próby losowany jest nowy zbiór pytań.',
    'about.safeguard': 'Zabezpieczenie rekrutacji',
    'about.decision': 'Jedno źródło informacji - nie decyzja o zatrudnieniu',
    'about.decisionText':
      'Pracodawcy muszą połączyć wyniki z ustrukturyzowanymi wywiadami, odpowiednim doświadczeniem i oceną przez człowieka.Platforma nie oznacza kandydatów jako zatrudnionych lub odrzuconych.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  cs: {
    'about.eyebrow': 'Měřeno s péčí. Vysvětleno v kontextu.',
    'about.title': 'Jasnější pohled na kognitivní silné stránky',
    'about.lede':
      'Výsledky jsou odhady s rozsahem spolehlivosti – nejsou to diagnózy ani konečné verdikty o osobě, ale spíše hodnocení schopnosti uvažovat abstraktně, numericky, slovně a prostorově.',
    'about.startTest': 'Start the free 40-question test',
    'about.testNote': 'Pro každý pokus je vylosována nová vyvážená sada otázek.',
    'about.safeguard': 'Ochrana při náboru',
    'about.decision': 'Jeden zdroj informací - ne rozhodnutí o přijetí',
    'about.decisionText':
      'Zaměstnavatelé musí kombinovat výsledky strukturovaných pohovorů, relevantní zkušenosti a lidské hodnocení, aby mohli najít vhodné kandidáty pro jejich pozici.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  sk: {
    'about.eyebrow': 'Starostlivo merané. Vysvetlené v kontexte.',
    'about.title': 'Jasnejší pohľad na kognitívne silné stránky',
    'about.lede':
      'Vykonajte adaptívne hodnotenie abstraktného, numerického, verbálneho a priestorového uvažovania.Výsledky sú odhady s rozsahom spoľahlivosti - nie diagnóza alebo konečný verdikt o osobe.',
    'about.startTest': 'Začnite voľný 40-question test -test',
    'about.testNote': 'Pre každý pokus sa vylosuje nová vyvážená sada otázok.',
    'about.safeguard': 'Ochranné opatrenia pri nábore',
    'about.decision': 'Jeden zdroj informácií - nie rozhodnutie o nábore',
    'about.decisionText':
      'Zamestnávatelia musia kombinovať výsledky štruktúrovaných pohovorov, relevantné skúsenosti a ľudské hodnotenie, aby mohli zamestnávať ľudí, ktorí sú schopní splniť ich požiadavky.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  hu: {
    'about.eyebrow': 'Gondosan mérve. A kontextusban magyarázva.',
    'about.title': 'Tisztább kép a kognitív erősségekről',
    'about.lede':
      'Az eredmények egy megbízhatósági tartományon belüli becslések, nem pedig diagnózis vagy végső ítélet egy személyről, és nem helyettesítik a személyiségtesztet, amelyet a személyiségteszt-szolgáltató végez.',
    'about.startTest': 'Kezdje a szabad játék 40- kérdés teszt',
    'about.testNote':
      'Minden egyes próbálkozáshoz egy új kiegyensúlyozott kérdéskészlet kerül kisorsolásra.',
    'about.safeguard': 'A toborzási biztosíték',
    'about.decision': 'Egyetlen információforrás – nem a felvételi döntés',
    'about.decisionText':
      'A munkáltatóknak az eredményeket strukturált interjúkkal, releváns tapasztalatokkal és emberi értékeléssel kell kombinálniuk, és a platform nem jelöli meg a jelölteket felvételként vagy elutasításként.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  sl: {
    'about.eyebrow': 'Previdno izmerjeno. Razloženo v kontekstu.',
    'about.title': 'Jasnejši pogled na kognitivne prednosti',
    'about.lede':
      'Izpolnite prilagodljivo oceno abstraktnega, numeričnega, verbalnega in prostorskega sklepanja.Rezultati so ocene z intervalom zaupanja - ne diagnoza ali končna sodba o osebi.',
    'about.startTest': 'Začnite brezplačno 40-question test',
    'about.testNote': 'Za vsak poskus se izžreba nov uravnotežen sklop vprašanj.',
    'about.safeguard': 'Zaščita pri zaposlovanju',
    'about.decision': 'En vir informacij - ne odločitev o zaposlitvi',
    'about.decisionText':
      'Delodajalci morajo združiti rezultate strukturiranih intervjujev, relevantnih izkušenj in človeškega pregleda, da bi lahko ocenili, ali je kandidat primeren za zaposlitev.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  ro: {
    'about.eyebrow': 'Măsurat cu atenție. Explicat în context.',
    'about.title': 'O viziune mai clară asupra punctelor forte cognitive',
    'about.lede':
      'Rezultatele sunt estimări cu un interval de încredere - nu un diagnostic sau un verdict final despre o persoană, ci o evaluare a abilităților de raționament abstract, numeric, verbal și spațial.',
    'about.startTest': 'Începeți jocul gratuit 40-test de întrebare',
    'about.testNote': 'Pentru fiecare încercare se extrage un nou set de întrebări echilibrate.',
    'about.safeguard': 'Garanția de recrutare',
    'about.decision': 'O singură sursă de informații - nu o decizie de angajare',
    'about.decisionText':
      'Angajatorii trebuie să combine rezultatele cu interviuri structurate, experiență relevantă și evaluare umană, iar platforma nu etichetează candidații ca angajați sau respinși.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  bg: {
    'about.eyebrow': 'Измерени с внимание. Обяснени в контекст.',
    'about.title': 'По-ясен поглед към когнитивните силни страни',
    'about.lede':
      'Резултатите са приблизителни оценки с доверителен интервал - не са диагноза или окончателна присъда за дадено лице, а са оценка на умението на човека да разсъждава по абстрактни, числени, вербални и пространствени начини.',
    'about.startTest': 'Започнете свободното. 40- въпрос тест',
    'about.testNote': 'За всеки опит се изтегля нов балансиран набор от въпроси.',
    'about.safeguard': 'Защита при набиране на персонал',
    'about.decision': 'Един източник на информация - не решение за наемане',
    'about.decisionText':
      'Работодателите трябва да комбинират резултатите от структурираните интервюта, съответния опит и човешкия преглед, за да могат да оценят кандидатите и да ги наемат или отхвърлят.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  uk: {
    'about.eyebrow': 'Обережно виміряно, пояснено в контексті.',
    'about.title': 'Яскравіший огляд когнітивних сил',
    'about.lede':
      'Завершити адаптивну оцінку абстрактного, числового, вербального і просторового мислення. Результати є оцінками з довірчим діапазоном — а не діагнозом або остаточним висновком щодо особи.',
    'about.startTest': 'Запустити вільний 40- тест на питання',
    'about.testNote': 'Для кожної спроби буде намальовано новий збалансований набір питань.',
    'about.safeguard': 'Захист від набору',
    'about.decision': 'Одне джерело інформації - не рішення щодо найму',
    'about.decisionText':
      'Працівники повинні поєднувати результати зі структурованими інтерв’ ю, відповідним досвідом та переглядом людьми. Платформа не позначає кандидатів як найнятих або відхилених.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  be: {
    'about.eyebrow': 'Вымерана з асцярожнасцю. Паяснена з кантэкстам.',
    'about.title': 'Чыстыя дадзеныя пра когнітыўныя сілы',
    'about.lede':
      'Выканаць адаптыўную ацэнку абстрактнага, лікавага, вербальнага і прасторавага мыслення. Вынікі - гэта ацэнкі з дыяпазонам даверу - не дыягназ або канчатковы вердыкт пра чалавека.',
    'about.startTest': 'Пачаць гульню 40- question test',
    'about.testNote': 'Усе выяўленыя ў ёй рэчывы з\u0027яўляюцца вынікам доўгага працэсу.',
    'about.safeguard': 'Захаванне рэкрутынгу',
    'about.decision': 'Адзін крыніца інфармацыі - не рашэнне аб найме',
    'about.decisionText':
      'Працадаўцы павінны сумяшчаць вынікі са структураванымі інтэрв\u0027ю, адпаведным вопытам і людскім аглядам. Платформа не маркуе кандыдатаў як наймаць або адхіляць.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  ru: {
    'about.eyebrow': 'Измерено с осторожностью. Объяснено с контекстом.',
    'about.title': 'Более ясное представление о когнитивных сильных сторонах',
    'about.lede':
      'Завершите адаптивную оценку абстрактного, численного, вербального и пространственного мышления. Результаты являются оценками с доверительным интервалом - не диагнозом или окончательным вердиктом о человеке.',
    'about.startTest': 'Начать свободно 40-тест вопросов',
    'about.testNote': 'Для каждой попытки выбирается новый сбалансированный набор вопросов.',
    'about.safeguard': 'Гарантии при найме',
    'about.decision': 'Один источник информации - не решение о найме',
    'about.decisionText':
      'Работодатели должны сочетать результаты со структурированными интервью, соответствующим опытом и человеческим обзором. Платформа не помечивает кандидатов как наем или отклонение.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  hr: {
    'about.eyebrow': 'Pažljivo izmjereno, objašnjeno u kontekstu.',
    'about.title': 'Jasniji pogled na kognitivne snage',
    'about.lede':
      'Provedite prilagodljivu procjenu apstraktnog, numeričkog, verbalnog i prostornog razmišljanja.Rezultati su procjene s rasponom pouzdanosti - ne dijagnoza ili konačna presuda o osobi.',
    'about.startTest': 'Počnite besplatno. 40-pitanje test',
    'about.testNote': 'Za svaki pokušaj izvlači se novi uravnoteženi skup pitanja.',
    'about.safeguard': 'Zaštitna mjera za zapošljavanje',
    'about.decision': 'Jedan izvor informacija - ne odluka o zapošljavanju',
    'about.decisionText':
      'Poslodavci moraju kombinirati rezultate strukturiranih intervjua, relevantnog iskustva i ljudskog pregleda, a platforma ne označava kandidate kao zaposlene ili odbijene.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  sr: {
    'about.eyebrow': 'Пажљиво измерено, објашњено у контексту.',
    'about.title': 'Јаснији поглед на когнитивне снаге',
    'about.lede':
      'Завршите адаптивну процену апстрактног, нумеричког, вербалног и просторног размишљања. Резултати су процене са интервалом поверења - а не дијагноза или коначна пресуда о особи.',
    'about.startTest': 'Почетак слободе 40-питање тест',
    'about.testNote': 'Нови балансирани скуп питања је извучен за сваки покушај.',
    'about.safeguard': 'Резерва за заштиту',
    'about.decision': 'Један извор информација - не одлука о запошљавању',
    'about.decisionText':
      'Послодавци морају да комбинују резултате са структурираним интервјуима, релевантним искуствима и људским прегледом.Платформа не обележава кандидате као запослене или одбијене.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  bs: {
    'about.eyebrow': 'Pažljivo izmjereno, objašnjeno u kontekstu.',
    'about.title': 'Jasniji pogled na kognitivne snage',
    'about.lede':
      'Završite prilagodljivu procjenu apstraktnog, numeričkog, verbalnog i prostornog razmišljanja. Rezultati su procjene sa intervalom pouzdanosti - ne dijagnoza ili konačna presuda o osobi.',
    'about.startTest': 'Počni slobodno. 40-test pitanja',
    'about.testNote': 'Svaki pokušaj se vrši sa novim uravnoteženim skupom pitanja.',
    'about.safeguard': 'Zaštita regrutiranja',
    'about.decision': 'Jedan izvor informacija - ne odluka o zapošljavanju',
    'about.decisionText':
      'Poslodavci moraju kombinirati rezultate sa strukturiranim intervjuima, relevantnim iskustvom i ljudskim pregledom. platforma ne označava kandidate kao zaposlene ili odbijene.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  cnr: {
    'about.eyebrow': 'Пажљиво измерено, објашњено контекстом.',
    'about.title': 'Јаснији поглед на когнитивне снаге',
    'about.lede':
      'Завршите адаптивну процену апстрактног, нумеричког, вербалног и просторног размишљања. Резултати су процене са опсегом поверења - а не дијагноза или коначна пресуда о особи.',
    'about.startTest': 'Почетак слободе 40-питање тест',
    'about.testNote': 'Нови балансирани скуп питања је извучен за сваки покушај.',
    'about.safeguard': 'Резерва за заштиту',
    'about.decision': 'Један извор информација - не одлука о запошљавању',
    'about.decisionText':
      'Послодавци морају да комбинују резултате са структурираним интервјуима, релевантним искуствима и људским прегледом.Платформа не обележава кандидате као запослене или одбијене.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  sq: {
    'about.eyebrow': 'E matur me kujdes, e shpjeguar me kontekst.',
    'about.title': 'Një pamje më e qartë e forcave njohëse',
    'about.lede':
      'Përfundo një vlerësim adaptiv në arsyetimin abstrakt, numerik, verbal dhe hapësinor. Rezultatet janë vlerësime me një interval besimi - jo një diagnozë apo një verdikt përfundimtar rreth një personi.',
    'about.startTest': 'Fillo të lirë 40- pyetje test',
    'about.testNote': 'Një set i ri i ekuilibruar pyetjesh tërhoqet për çdo orvatje.',
    'about.safeguard': 'Siguria e rekrutimit',
    'about.decision': 'Një burim informacioni - jo një vendim punësimi',
    'about.decisionText':
      'Punëdhënësit duhet të kombinojnë rezultatet me intervistat e strukturuara, përvojën e duhur dhe shqyrtimin njerëzor. Platforma nuk i etiketon kandidatët si të punësuar apo të kundërshtuar.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  mk: {
    'about.eyebrow': 'Внимателно измерено, објаснето со контекст.',
    'about.title': 'Појасен поглед на когнитивните предности',
    'about.lede':
      'Заврши адаптивна проценка преку апстрактно, нумеричко, вербално и просторно размислување. Резултатите се проценки со доверлив опсег - не дијагноза или конечна пресуда за личноста.',
    'about.startTest': 'Почни го слободниот ход. 40-Прашање тест',
    'about.testNote': 'Секој нов обид за полнење се оценува со по еден поен.',
    'about.safeguard': 'Заштита при регрутирање',
    'about.decision': 'Еден извор на информации - не одлука за вработување',
    'about.decisionText':
      'Работодавците мора да ги комбинираат резултатите со структурирани интервјуа, релевантно искуство и човечки преглед.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  lt: {
    'about.eyebrow': 'Išmatuota atsargiai. Paaiškinta kontekste.',
    'about.title': 'Aiškiau matyti kognityvines stipriąsias puses',
    'about.lede':
      'Atlikite prisitaikantį vertinimą abstrakčiojo, skaitinio, žodinio ir erdvinio mąstymo srityje.Rezultatai yra įvertinimai su pasitikėjimo intervalu - ne diagnozė ar galutinis verdiktas apie asmenį.',
    'about.startTest': 'Pradėti nemokamą 40-question testas',
    'about.testNote': 'Kiekvienam bandymui yra parenkamas naujas subalansuotas klausimų rinkinys.',
    'about.safeguard': 'Įdarbinimo apsaugos priemonė',
    'about.decision': 'Vienas informacijos šaltinis – ne įdarbinimo sprendimas',
    'about.decisionText':
      'Darbdaviai turi derinti rezultatus su struktūrizuotais pokalbiais, atitinkama patirtimi ir žmogaus peržiūra, kad galėtų nustatyti, ar kandidatas yra tinkamas.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  lv: {
    'about.eyebrow': 'Rūpīgi izmērīti. Izskaidroti kontekstā.',
    'about.title': 'Skaidrāks priekšstats par kognitīvajām spējām',
    'about.lede':
      'Pabeidziet adaptīvo novērtējumu abstraktās, skaitliskās, verbālās un telpiskās domāšanas jomās.Rezultāti ir aplēses ar ticamības diapazonu - nevis diagnoze vai galīgais spriedums par personu.',
    'about.startTest': 'Sākt bezmaksas 40-jautājums tests',
    'about.testNote': 'Par katru mēģinājumu tiek izlozēta jauna līdzsvarota jautājumu kopa.',
    'about.safeguard': 'Darbā pieņemšanas aizsardzība',
    'about.decision': 'Viens informācijas avots - nevis pieņemšanas darbā lēmums',
    'about.decisionText':
      'Darba devējiem ir jāapvieno rezultāti ar strukturētām intervijām, atbilstošu pieredzi un cilvēka veiktu pārskatu, lai novērtētu kandidātus.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  et: {
    'about.eyebrow': 'Mõõdetud hoolikalt. Selgitatud kontekstis.',
    'about.title': 'Selgem ülevaade kognitiivsetest tugevustest',
    'about.lede':
      'Tulemused on usaldusvahemiku hinnangud, mitte diagnoos või lõplik otsus inimese kohta, mistõttu on oluline, et tulemused oleksid õiged ja et need oleksid õigesti määratletud.',
    'about.startTest': 'Alusta tasuta 40-küsimus test',
    'about.testNote': 'Iga katse puhul loositakse välja uus tasakaalustatud küsimuste komplekt.',
    'about.safeguard': 'Värbamise kaitse',
    'about.decision': 'Üks teabeallikas – mitte töölevõtmise otsus',
    'about.decisionText':
      'Tööandjad peavad kombineerima tulemused struktureeritud intervjuude, asjakohase kogemuse ja inimese poolt läbiviidud hindamisega, et leida sobiv kandidaat.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  ga: {
    'about.eyebrow': 'Ag tabhairt freagra ar context.',
    'about.title': 'Amharc níos soiléire ar láidreachtaí cognaíocha',
    'about.lede':
      'Measúnú oiriúnaitheach a dhéanamh ar réasúnaíocht theibí, uimhriúil, bhriathartha agus spásúil. Is meastacháin iad na torthaí le raon muiníne. Ní diagnóis ná breithiúnas deiridh iad maidir le duine.',
    'about.startTest': 'Tosaigh an saor in aisce 40- question test',
    'about.testNote': 'Tarraingítear tacar nua ceisteanna cothromaithe do gach iarracht.',
    'about.safeguard': 'Cosaint earcaíochta',
    'about.decision': 'Foinse amháin eolais - ní cinneadh fostaíochta',
    'about.decisionText':
      'Ní mór d’fhostóirí torthaí a chur le chéile le hagallaimh struchtúrtha, taithí ábhartha, agus athbhreithniú daonna.Ní lipéadaíonn an t-ardán iarrthóirí mar fhostú nó diúltú.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  cy: {
    'about.eyebrow': 'Mesurwyd yn ofalus. Esboniwyd gyda chyfundrefn.',
    'about.title': 'Golwg gliriach o gryfderau cofiadwy',
    'about.lede':
      'Cwblhau archwiliad addasu ar draws rhesymu disgrifiadol, rhifol, iaith a lloeren. Amcangyfrifon yw\u0027r canlyniadau gydag amrediad ymddiriedaeth - nid diagnosteg na phenderfyniad terfynol am berson.',
    'about.startTest': 'Dechrau\u0027r rhydd 40-question test',
    'about.testNote': 'Lluniwyd set gwestiynau newydd wedi\u0027 i chydbwyso ar gyfer pob ceisio.',
    'about.safeguard': 'Diogelwch recriwtio',
    'about.decision': 'Un ffynhonnell wybodaeth - nid penderfyniad i gyflogi',
    'about.decisionText':
      'Rhaid i gyflogwyr gyfuno canlyniadau gyda chyfweliadau strwythuredig, profiad perthnasol, ac adolygiad dynol. Nid yw\u0027r platfform yn labelu ymgeiswyr fel cyflogi neu wrthod.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  gd: {
    'about.eyebrow': 'Measaichte gu faiceallach. Mìneachadh le co-theacsa.',
    'about.title': 'Seall nas soilleire air neartan co-fhiosrachail',
    'about.lede':
      'Crìochnaich measadh atharrachaidh air a’ bheachdachadh neo-bhàsmhor, àireamhach, beòil is sgeamasach. Is e measan le raon cinnteach a th’ anns na toraidhean – chan e diagnosis no breithneachadh deireannach mu neach.',
    'about.startTest': 'Start the free 40-question test',
    'about.testNote':
      'Thèid taghadh ùr de cheistean cothromaichte a tharraing airson gach feuchainn.',
    'about.safeguard': 'Recruitment safeguard',
    'about.decision': 'Aon stòr fiosrachaidh - chan e cinneadh a tha a’ gabhail obrach',
    'about.decisionText':
      'Feumaidh luchd-obrach na toraidhean a chur còmhla le agallamhan structaraichte, eòlas iomchaidh, agus ath-bhreithneachadh daonna. Chan eil an àrd-ùrlar a’ cur lipéad ar iarrthóirí mar fhostú nó diúltú.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  iu: {
    'about.eyebrow': 'ᖃᐅᔨᓴᑦᑎᐊᖅᓯᒪᓪᓗᑎᒃ, ᓇᓗᓇᐃᔭᖅᓯᒪᑦᑎᐊᖅᖢᑎᒃ.',
    'about.title': 'ᑐᑭᓯᓇᖅᓯᓂᖅᓴᐅᓗᓂ ᑕᐅᑐᒐᕆᔭᐅᔪᖅ ᐃᓱᒪᓕᕆᓂᕐᒧᑦ ᓴᓐᖏᓂᐅᔪᓄᑦ',
    'about.lede':
      'ᐱᔭᕇᖅᓯᓗᑎᒃ ᖃᐅᔨᓴᐃᓂᕐᒥᒃ ᐊᑐᕈᓐᓇᕐᓗᑎᒃ ᐃᓱᒪᓕᐅᕈᓐᓇᕐᓗᑎᒃ ᓈᓴᐅᑎᓂᒃ, ᐅᖃᐅᓯᒃᑯᑦ, ᐊᒻᒪᓗ ᓇᓕᖅᑲᓂᒃ, ᖃᐅᔨᔭᐅᔪᑦ ᓇᓚᐅᑦᑖᖅᑕᐅᕗᑦ ᓇᓗᓇᓐᖏᑦᑐᒃᑯᑦ - ᖃᐅᔨᔭᐅᔾᔪᑎᐅᖏᑦᑐᖅ ᐅᕝᕙᓘᓐᓃᑦ ᑭᖑᓪᓕᖅᐹᒥᒃ ᐃᓱᒪᓕᐅᕈᑕᐅᔪᖅ ᑭᓇᑐᐃᓐᓇᕐᒧᑦ.',
    'about.startTest': 'ᐱᒋᐊᖅᑎᑕᐃᑦ 40- ᐊᐱᖅᑯᑎᑦ ᖃᐅᔨᓴᖅᑕᐅᓂᖏᑦ',
    'about.testNote': 'ᓄᑖᖅ ᐊᔾᔨᒌᓕᖅᑎᑕᐅᔪᖅ ᐊᐱᖅᑯᑎᒃᓴᐃᑦ ᓴᖅᑭᑕᐅᓲᖑᕗᑦ ᐆᑦᑐᕋᐅᑎᓕᒫᓄᑦ.',
    'about.safeguard': 'ᐃᖅᑲᓇᐃᔭᖅᑎᑖᕐᓂᕐᒧᑦ ᓴᐳᒻᒥᔭᐅᔾᔪᑎ',
    'about.decision': 'ᐊᑕᐅᓯᖅ ᑐᑭᓯᒋᐊᕈᑎᒃᓴᐅᔪᖅ - ᐃᖅᑲᓇᐃᔭᖅᑎᑖᕐᓂᕐᒧᑦ ᐃᓱᒪᓕᐅᕈᑕᐅᙱᒻᒪᑦ',
    'about.decisionText':
      'ᐃᖅᑲᓇᐃᔭᖅᑎᑦᑎᔩᑦ ᑲᑎᖅᓱᐃᔭᕆᐊᖃᖅᐳᑦ ᖃᐅᔨᔭᐅᓯᒪᔪᓂᒃ ᐊᐱᖅᓱᖅᑕᐅᓂᒃᑯᑦ, ᐱᔪᓐᓇᕐᓂᖃᑦᑎᐊᖅᓯᒪᓂᒃᑯᑦ ᐊᒻᒪᓗ ᐃᓄᓐᓄᑦ ᕿᒥᕐᕈᔭᐅᓂᒃᑯᑦ, ᐊᒻᒪᓗ ᑕᐃᒃᑯᐊ ᐃᖅᑲᓇᐃᔭᖅᑎᑖᕋᓱᐊᖅᑐᑦ ᐃᖅᑲᓇᐃᔭᖅᑎᑖᖅᑎᑕᐅᖃᑦᑕᖏᒻᒪᑕ ᐅᕝᕙᓘᓐᓃᑦ ᐊᖏᖅᑕᐅᖃᑦᑕᖏᒻᒪᑕ.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  cr: {
    'about.eyebrow': 'Mākēw ispayiki ispayiki ohci ohci ohci ohci ohci.',
    'about.title':
      'A cētcih tahtocik cēhcih cēhcih cēhcih cēhcih cēhcih cēhcih cēhcih cēhcih cēhcih cēhcih cēhcih cēhcih cēhcih cēhcih cēhcih cēhcih cēhcih cēhcih cēhcih cēhcih',
    'about.lede':
      'Oski-na-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki-ki',
    'about.startTest':
      '1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1 40-question test',
    'about.testNote': 'A new balanced question set is drawn for every attempt.',
    'about.safeguard': 'Recruitment safeguard',
    'about.decision': 'One source of information - not a hiring decision',
    'about.decisionText':
      'E-workers ēkwa employers ēkwa employers ēkwa employers ēkwa employers ēkwa employers ēkwa employers ēkwa employers ēkwa employers ēkwa employers ēkwa employers ēkwa employers.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  nv: {
    'about.eyebrow': 'Tʼáá áłtsʼíísígíí éí tʼáá átʼé.',
    'about.title':
      'A clearer view of cognitive strengths - Naakaii Łizhiní Bikéyahdę́ę́ʼ tłʼiishkʼaaʼii',
    'about.lede':
      'Ałhiníʼgo, áłtsé éí áłtsé éí áłtsé éí ááháʼiiʼgo, áłtsé éí ááháʼiiʼgo, áłtsé éí ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼiiʼgo, ááháʼii',
    'about.startTest': 'Tʼáá ałtsoní 40-question test',
    'about.testNote': 'Ałtso nihookááʼ daʼałtʼoʼígíí éí nihookááʼ daʼałtʼoʼígíí beeʼaasdzooʼígíí.',
    'about.safeguard': 'Recruitment safeguard',
    'about.decision': 'Díí naaltsoos bikáaʼgi éí 100 ałʼąą ádaatʼé - éí 100 ałʼąą ádaatʼé',
    'about.decisionText':
      'Haʼaʼaahdę́ę́ʼ kááʼtsʼiní éí kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó kááʼtsʼiní dóó',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  qu: {
    'about.eyebrow': 'Medido cuidadosamente. Explicado con contexto.',
    'about.title': 'Una vista mas clara de las fortalezas cognitivas',
    'about.lede':
      'Qhawariy imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas, imakunas,',
    'about.startTest': '1999 - 2001: 40-question test',
    'about.testNote':
      'Chayman hina, huk nuevo conjunto de preguntas balanceadas se dibuja para cada intento.',
    'about.safeguard': 'Recruitment safeguard',
    'about.decision': 'Una fuente de información - no una decisión de contratación',
    'about.decisionText':
      'Kay plataformaqa manan hukniraychu candidatokunata contratanapaq nitaq rechazanapaq, aswanpas wawankukunatam, experienciata, imakunatam chaskinmanku, allinpaq qhawarin.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  gn: {
    'about.eyebrow': 'Ojehecha porãva\u0027erã. Ojeikuaaukava\u0027erã contexto rupive.',
    'about.title': 'Peteĩ visión hesakãvéva mbaretekue cognitiva rehegua.',
    'about.lede':
      'Oñemohu\u0027ã peteĩ evaluación adaptativa razonamiento abstracto, numérico, verbal ha espacial rupive. Umi resultado hína estimación peteĩ rango de confianza rehe, ndaha\u0027éi peteĩ diagnóstico térã peteĩ veredicto final peteĩ tapicha rehegua.',
    'about.startTest': 'Oñepyrũva\u0027ekue 40-question test',
    'about.testNote':
      'Oñemohenda peteĩ ñeporandu aty pyahu ojehecha hag̃ua peteĩteĩ umi ñeha\u0027ã.',
    'about.safeguard': 'Reclutamiento rehegua garantía',
    'about.decision':
      'Peteĩ fuente marandu rehegua - ndaha\u0027éi peteĩ decisión jeporavo rehegua.',
    'about.decisionText':
      'Umi mba\u0027apohára ojokupyty va\u0027erã umi ojehupytýva entrevista estructurada rupive, experiencia relevante ha tapicha jesareko rupive, ha ko plataforma ndojokupytýi umi candidato rehe ojeiporavo térã oñemboyke hag̃ua.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  ay: {
    'about.eyebrow':
      'Aka mä mä qhawqhanxa, mä qhawqhanxa, mä qhawqhanxa, mä qhawqhanxa, mä qhawqhanxa.',
    'about.title': 'Una mirada más clara de las fortalezas cognitivas',
    'about.lede':
      'Taqiniw mä evaluación adaptativa lurani, razonamiento abstracto, numérico, verbal, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata, ukata,',
    'about.startTest': '100% libre 40-question test',
    'about.testNote':
      'Aka uruxa, mä suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma suma',
    'about.safeguard': 'Recruitment safeguard',
    'about.decision': 'Una fuente de información - no una decisión de contratación',
    'about.decisionText':
      'Ukampirusa, empleadornakajja, jan walt’äwinak lurat mä plataformanx janiw mä candidatot contratarti jan ukasti, jan walt’äwinak lurañatakis yanapt’añapäkiti.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  ht: {
    'about.eyebrow': 'Mezire ak anpil atansyon. Expliqués ak tèm.',
    'about.title': 'Yon gade pi klè nan fòs kognitif',
    'about.lede':
      'Konplete yon evalyasyon adaptif sou rezonman abstrè, nimewo, vèbal, ak spatial.Resultats yo estimasyon ak yon ran de konfidans - pa yon dyagnostik oswa yon verdik final sou yon moun.',
    'about.startTest': 'Start the free 40-question test',
    'about.testNote': 'Yon nouvo seri kesyon balanse se te tire pou chak efò.',
    'about.safeguard': 'Recruitment safeguard',
    'about.decision': 'Yon sèl sous enfòmasyon - pa yon desizyon pou pran',
    'about.decisionText':
      'Employers dwe konbine rezilta yo ak entèvyou estrikti, eksperyans ki gen rapò, ak revize moun.Platfòm la pa étiquettes kandida kòm anboche oswa refize.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  pap: {
    'about.eyebrow': 'Mesura cu cuidado. Explica den contexto.',
    'about.title': 'Un bista mas cla di e fortanan cognitivo',
    'about.lede':
      'Completa un evaluacion adaptativo di razonamento abstracto, numerico, verbal y espacial.Resultadonan ta estimacionnan cu un rango di confiansa - no un diagnostico of un veredicto final tocante un persona.',
    'about.startTest': 'Start the free 40-question test -',
    'about.testNote': 'Un nuevo set di preguntanan balancea ta wordo tira pa cada intento.',
    'about.safeguard': 'Recruitment safeguard',
    'about.decision': 'Un fuente di informacion - no un decision di contratacion',
    'about.decisionText':
      'Empleadornan mester combina e resultadonan di e entrevistanan structura, e experiencia relevante y e evaluacion humano cu e plataforma no ta etiqueta candidatonan como contrata of rechasa.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  zh: {
    'about.eyebrow': '经过仔细测量,并根据上下文进行解释。',
    'about.title': '更清晰地了解认知优势',
    'about.lede':
      '完成抽象、数学、语言和空间推理的自适应评估。 结果是置信区间内的估计值,而不是对某人的诊断或最终判断。',
    'about.startTest': '自由之路 40问题测试',
    'about.testNote': '每次尝试都会抽取一组新的平衡问题。',
    'about.safeguard': '招聘保障',
    'about.decision': '一个信息来源 - 不是雇用决定',
    'about.decisionText':
      '雇主必须将结果与结构化面试、相关经验和人工审核相结合,而不会将候选人标记为雇用或拒绝。',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  yue: {
    'about.eyebrow': '仔細測量 ， 用背景來解釋',
    'about.title': '更清楚地看待認知能力的強項',
    'about.lede':
      '完成抽象、數值、語言和空間推理的自適應評估。 結果是具有置信範圍的估計值 - 不是診斷或對某人的最終判斷。',
    'about.startTest': '開始自由 40問題測驗',
    'about.testNote': '每次嘗試都會抽出一組新的平衡問題 。',
    'about.safeguard': '招募保障措施',
    'about.decision': '只有一個資訊來源 ， 不是雇用決定',
    'about.decisionText':
      '雇主必須將結果與結構化面試、相關經驗和人工評估結合在一起。 平台不會將候選人標記為聘用或拒絕。',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  ja: {
    'about.eyebrow': '慎重に計測し 文脈で説明した',
    'about.title': '認知力の明確な見方',
    'about.lede':
      '抽象的、数値的、言語的、空間的推論における適応的評価を完了します。結果は信頼区間を持つ推定値であり、診断や人物に関する最終判断ではありません。',
    'about.startTest': 'スタート・ザ・フリー 40質問テスト',
    'about.testNote': '各試行に対して新しいバランス問題集を抽出する。',
    'about.safeguard': '採用保障',
    'about.decision': '情報源は一つで 雇用決定はしない',
    'about.decisionText':
      '採用者は，構造化された面接，関連する経験，人間のレビューを結合する必要がある。',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  ko: {
    'about.eyebrow': '주의 깊게 측정하고 문맥에 따라 설명합니다.',
    'about.title': '인지적 강점에 대한 보다 명확한 보기',
    'about.lede':
      '추상적, 수치적, 언어적, 공간적 추론에 대한 적응형 평가를 완료합니다. 결과는 신뢰 범위를 가진 추정치이며, 진단이나 사람에 대한 최종 판단이 아닙니다.',
    'about.startTest': '무료 체험 시작 40-질문 테스트',
    'about.testNote': '각 시도마다 새로운 균형 잡힌 질문 세트가 그려집니다.',
    'about.safeguard': '채용 보호',
    'about.decision': '정보의 한 소스 - 고용 결정이 아닙니다',
    'about.decisionText':
      '고용주는 구조화된 인터뷰, 관련 경험, 인간 검토와 결과를 결합해야합니다. 플랫폼은 후보자를 고용 또는 거부로 라벨하지 않습니다.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  hi: {
    'about.eyebrow': 'सावधानी से मापा. संदर्भ के साथ समझाया.',
    'about.title': '1. नैतिकता की स्पष्टता।',
    'about.lede':
      'अमूर्त, संख्यात्मक, मौखिक तथा स्थानिक तर्क के माध्यम से अनुकूलनात्मक मूल्यांकन पूरा करें. परिणाम एक विश्वसनीय सीमा के साथ अनुमान हैं - एक निदान या किसी व्यक्ति के बारे में अंतिम निर्णय नहीं.',
    'about.startTest': 'मुक्त प्रारंभ करें 40- प्रश्न परीक्षण',
    'about.testNote': 'प्रत्येक प्रश्न के लिए एक नया संतुलित प्रश्न सेट बनाया जाता है।',
    'about.safeguard': 'भर्ती सुरक्षा',
    'about.decision': 'सूचना का एक स्रोत - कोई नियुक्ति निर्णय नहीं',
    'about.decisionText':
      'नियोक्ताओं को परिणामों को संरचित साक्षात्कारों, प्रासंगिक अनुभवों और मानव समीक्षा के साथ जोड़ना चाहिए. प्लेटफॉर्म उम्मीदवारों को नौकरी या अस्वीकार के रूप में लेबल नहीं करता है।',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  ur: {
    'about.eyebrow': 'احتیاط کے ساتھ پیمائش.',
    'about.title': 'شناختی قوتوں کا ایک واضح نظر',
    'about.lede':
      'تجريدي ، عددي ، لفظي اور فضائي استدلال کے ليے يک مناسب ايچ او پورا کريں نتيجے اعتماد کے رينج کے ساتھ تخمينے هے - انسان کے متعلق ايک تشخيص يا آخري فيصلہ نهيں',
    'about.startTest': 'مفت شروع کریں 40سوالي آزمائش',
    'about.testNote': 'هر کوشش کے ليے نئے متوازن سوالات کا سيٽ بنا يا جاتا هے',
    'about.safeguard': 'بھرتی حفاظت',
    'about.decision': 'ایک معلومات کا ذریعہ - ایک ملازمت کا فیصلہ نہیں',
    'about.decisionText': 'یہ پلیٹ فارم نامزدوں کو ملازمت یا رد کرنے کے طور پر لیبل نہیں کرتا ہے.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  bn: {
    'about.eyebrow': 'সাবধানে পরিমাপ করা, প্রসঙ্গের সাথে ব্যাখ্যা করা।',
    'about.title': 'জ্ঞানগত শক্তির একটি স্পষ্ট দৃষ্টিভঙ্গি',
    'about.lede':
      'বিমূর্ত, সংখ্যাগত, বাক্যগত এবং স্থানীয় যুক্তিবিজ্ঞানের উপর একটি অনুকূল মূল্যায়ন সম্পন্ন করুন। ফলাফলগুলি একটি বিশ্বাসযোগ্যতার পরিসীমার সাথে অনুমান করা হয় - একটি রোগ নির্ণয় বা একজন ব্যক্তির একটি চূড়ান্ত রায় নয়।',
    'about.startTest': 'মুক্ত শুরু করুন 40- প্রশ্ন পরীক্ষা',
    'about.testNote': 'প্রতিটি চেষ্টার জন্য একটি নতুন ভারসাম্যপূর্ণ প্রশ্ন সেট আঁকা হবে ।',
    'about.safeguard': 'নিয়োগ সুরক্ষা',
    'about.decision': 'তথ্যের একমাত্র উৎস - নিয়োগের সিদ্ধান্ত নয়',
    'about.decisionText':
      'কর্মদাতাদের অবশ্যই সাক্ষাৎকারের ফলাফল, অভিজ্ঞতা এবং মানুষের পর্যালোচনার সাথে মিলিয়ে নিতে হবে। এই প্ল্যাটফর্ম প্রার্থীদের নিয়োগ বা প্রত্যাখ্যান করে না।',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  pa: {
    'about.eyebrow': 'ਧਿਆਨ ਨਾਲ ਮਾਪਿਆ ਗਿਆ ਹੈ । ਸੰਬੰਧ ਨਾਲ ਦੱਸਿਆ ਗਿਆ ਹੈ ।',
    'about.title': 'ਸੰਵੇਦਨਸ਼ੀਲ ਤਾਕਤਾਂ ਦਾ ਇੱਕ ਸਪਸ਼ਟ ਦ੍ਰਿਸ਼ਟੀਕੋਣ',
    'about.lede':
      'ਇੱਕ ਅਨੁਕੂਲ ਮੁਲਾਂਕਣ ਪੂਰਾ ਕਰੋ, ਜੋ ਕਿ ਸੰਖੇਪ, ਅੰਕ, ਬੋਲੀ ਅਤੇ ਥਾਂਗਤ ਤਰਕ ਨਾਲ ਭਰਪੂਰ ਹੈ । ਨਤੀਜੇ ਇੱਕ ਵਿਸ਼ਵਾਸ ਰੇਜ਼ ਨਾਲ ਅਨੁਮਾਨਿਤ ਹਨ - ਇੱਕ ਨਿਦਾਨ ਜਾਂ ਇੱਕ ਵਿਅਕਤੀ ਬਾਰੇ ਇੱਕ ਅੰਤਮ ਫੈਸਲਾ ਨਹੀਂ ਹੈ ।',
    'about.startTest': 'ਮੁਫ਼ਤ ਸ਼ੁਰੂ 40-question ਟੈਸਟ',
    'about.testNote': 'ਹਰ ਕੋਸ਼ਿਸ਼ ਲਈ ਇੱਕ ਨਵਾਂ ਸਮਾਨ ਸਵਾਲ ਸੈੱਟ ਬਣਾਇਆ ਜਾਂਦਾ ਹੈ ।',
    'about.safeguard': 'ਭਰਤੀ ਸੁਰੱਖਿਆ',
    'about.decision': 'ਇੱਕ ਸਰੋਤ ਜਾਣਕਾਰੀ - ਇੱਕ ਨਿਯੁਕਤੀ ਫੈਸਲਾ ਨਹੀਂ',
    'about.decisionText':
      'ਨਿਯੁਕਤੀਕਰਤਾ ਨੂੰ ਨਤੀਜਿਆਂ ਨੂੰ ਸੰਗਠਿਤ ਇੰਟਰਵਿਊ, ਪ੍ਰਸੰਗਿਕ ਅਨੁਭਵ ਅਤੇ ਮਨੁੱਖੀ ਸਮੀਖਿਆ ਨਾਲ ਜੋੜਨਾ ਚਾਹੀਦਾ ਹੈ।',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  mr: {
    'about.eyebrow': 'याची माहिती देण्यासाठी खालील संदर्भ दिले आहेत.',
    'about.title': 'स्मृतीशक्ती वाढविण्यासाठीचे उपाय',
    'about.lede':
      'अमूर्त, संख्यात्मक, मौखिक व स्थानिक तर्कशास्त्राद्वारे अनुकूलन मूल्यमापन पूर्ण करा. परिणाम हे विश्वासार्हतेच्या कक्षेत अंदाजे आहेत - निदान किंवा व्यक्तीबद्दल अंतिम निर्णय नाही.',
    'about.startTest': 'मुक्त 40प्रश्न',
    'about.testNote': 'प्रत्येक प्रश्नाचे उत्तर देण्यासाठी एकच प्रश्न विचारला जातो.',
    'about.safeguard': 'भरती संरक्षण',
    'about.decision': 'एकच माहितीचा स्रोत - नोकरी देण्याचा निर्णय नाही',
    'about.decisionText':
      'यासाठी यंत्रणेने निरीक्षण, विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण, विश्लेषणात्मक विश्लेषण',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  gu: {
    'about.eyebrow': 'સાવચેતીથી માપવામાં આવ્યું. સંદર્ભ સાથે સમજાવ્યું.',
    'about.title': 'જ્ઞાનની ક્ષમતાઓનું વધુ સ્પષ્ટ દ્રષ્ટિકોણ',
    'about.lede':
      'સંકલિત, સંખ્યાત્મક, વાક્ય અને સ્થાનિક તર્ક પર અનુરૂપ મૂલ્યાંકન પૂરુ કરો. પરિણામો વિશ્વાસની રેન્જ સાથે અંદાજ છે - કોઈ વ્યક્તિ વિશે નિદાન અથવા અંતિમ વચન નથી.',
    'about.startTest': 'મુક્ત શરૂ કરો 40- પ્રશ્ન ચકાસણી',
    'about.testNote': 'દરેક પ્રયત્ન માટે નવું સંતુલિત પ્રશ્ન સમૂહ દોરવામાં આવે છે.',
    'about.safeguard': 'ભરતી સુરક્ષા',
    'about.decision': 'માહિતીનો એક જ સ્ત્રોત - નોકરી આપવાનો નિર્ણય નથી',
    'about.decisionText':
      'રોજગારદાતાઓએ પરિણામોને સંરચિત ઇન્ટરવ્યુ, સંબંધિત અનુભવ અને માનવ સમીક્ષા સાથે જોડવું જોઈએ.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  ta: {
    'about.eyebrow': 'கவனமாக அளவிடப்பட்டது. சூழல் விளக்கப்பட்டது.',
    'about.title': 'அறிவாற்றல் வலிமைகளின் தெளிவான பார்வை',
    'about.lede':
      'ஒரு பொருத்தமான மதிப்பீட்டை முழுமையாக்கு, எண்ணிக்கை, வார்த்தை, மற்றும் இடம் சார்ந்த தர்க்கம். முடிவுகள் நம்பகமான அளவுகளுடன் மதிப்பீடுகள் - ஒரு அறிகுறி அல்லது ஒரு மனிதனைப் பற்றிய ஒரு முடிவு தீர்ப்பு அல்ல.',
    'about.startTest': 'ஸ்டார்ட் த ஃப்ரீ 40- கேள்வி சோதனை',
    'about.testNote': 'ஒவ்வொரு முயற்சிக்கும் ஒரு புதிய சமநிலை கேள்வி அமைப்பு வரையறுக்கப்படுகிறது.',
    'about.safeguard': 'பணியமர்த்தல் பாதுகாப்பு',
    'about.decision': 'ஒரு தகவல் மூலமாக - ஒரு வேலைக்கு எடுக்கும் முடிவு அல்ல',
    'about.decisionText':
      'வேலையாட்கள் கட்டமைக்கப்பட்ட நேர்காணல்களுடன் முடிவுகளை இணைக்க வேண்டும், சம்பந்தப்பட்ட அனுபவம், மற்றும் மனித மதிப்பீடு. இந்த தளம் வேலைக்கு அல்லது நிராகரித்தல் என வேட்பாளர்களை லேபிள் செய்யாது.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  te: {
    'about.eyebrow': 'జాగ్రత్తగా మదింపు. సంభాషణతో వివరించారు.',
    'about.title': 'జ్ఞాపక శక్తి యొక్క స్పష్టమైన దృక్పథం',
    'about.lede':
      'ఒక అనుకూలమైన అంచనాను పూర్తిచేయండి, అబ్స్ట్రక్ట్, సంఖ్యాత్మక, వాచక, మరియు స్పేషియల్ రీజన్. ఫలితాలు ఒక విశ్వాస పరిధితో అంచనాలు - ఒక వ్యక్తి గురించి ఒక నిర్ధారణ లేదా ఒక చివరి తీర్పు కాదు.',
    'about.startTest': 'ఉచిత ప్రారంభించండి 40- ప్రశ్న పరీక్ష',
    'about.testNote': 'ప్రతి నవలలో ఒక కొత్త కథను ప్రవేశపెట్టడం ఈ నవలలో ప్రత్యేకత.',
    'about.safeguard': 'నియామక భద్రత',
    'about.decision': 'ఒక సమాచారం మూలం - ఒక నియమించే నిర్ణయం కాదు',
    'about.decisionText':
      'ఉద్యోగులు రూపొందించిన ఇంటర్వ్యూలతో ఫలితాలను కలపాలి, సంబంధిత అనుభవం, మరియు మానవ సమీక్ష.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  kn: {
    'about.eyebrow': 'ಎಚ್ಚರಿಕೆಯಿಂದ ಅಳೆಯಲಾಗಿದೆ. ಸಂದರ್ಭದೊಂದಿಗೆ ವಿವರಿಸಲ್ಪಟ್ಟಿದೆ.',
    'about.title': 'ಜ್ಞಾನದ ಬಲದ ಸ್ಪಷ್ಟ ದೃಷ್ಟಿಕೋನ',
    'about.lede':
      'ಅಮೂರ್ತ, ಸಂಖ್ಯೆಯ, ವಾಕ್ಯ, ಮತ್ತು ಸ್ಥಳೀಯ ಯೋಚನೆಗಳ ಮೂಲಕ ಒಂದು ಹೊಂದಿಕೊಳ್ಳುವ ಅಂದಾಜನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ. ಫಲಿತಾಂಶಗಳು ವಿಶ್ವಾಸದ ವ್ಯಾಪ್ತಿಯೊಂದಿಗೆ ಅಂದಾಜುಗಳು - ವ್ಯಕ್ತಿಯ ಬಗ್ಗೆ ಒಂದು ರೋಗನಿರ್ಣಯ ಅಥವಾ ಅಂತಿಮ ತೀರ್ಪು ಅಲ್ಲ. Name',
    'about.startTest': 'ಮುಕ್ತ 40ಪ್ರಶ್ನೆ',
    'about.testNote': 'ಪ್ರತಿ ಪ್ರಯತ್ನಕ್ಕೂ ಒಂದು ಹೊಸ ಸಮತೋಲಿತ ಪ್ರಶ್ನೆಯ ಗುಂಪನ್ನು ಎಳೆಯಲಾಗುತ್ತದೆ.',
    'about.safeguard': 'ನೇಮಕಾತಿ ಸುರಕ್ಷತೆ',
    'about.decision': 'ಮಾಹಿತಿಯ ಒಂದು ಮೂಲ - ನೇಮಕಾತಿ ನಿರ್ಧಾರವಲ್ಲ',
    'about.decisionText':
      'ಉದ್ಯೋಗದಾತರು ಸ್ಥಿರವಾದ ಸಂದರ್ಶನ, ಸಂಬಂಧಿತ ಅನುಭವ ಮತ್ತು ಮಾನವ ಪರಿಶೀಲನೆಯೊಂದಿಗೆ ಫಲಿತಾಂಶಗಳನ್ನು ಸಂಯೋಜಿಸಬೇಕು.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  ml: {
    'about.eyebrow': 'ശ്രദ്ധയോടെ അളന്നു, വിശദീകരിച്ചു.',
    'about.title': 'മനഃശാസ്ത്രപരമായ ശക്തികളെക്കുറിച്ചുള്ള വ്യക്തമായ കാഴ്ചപ്പാട്',
    'about.lede':
      'ഒരു ആപ്റ്റിവല്‍ എവറേജ് പൂര്‍ത്തീകരിക്കുക, അസംബ്ലിക്, നമ്പര്‍, വാചക, സ്ഥല ന്യായീകരണങ്ങള്‍. ഫലങ്ങള്‍ ഒരു വിശ്വാസ പരിധിയിലുള്ള കണക്കുകൂട്ടലുകളാണ് - ഒരു രോഗനിര്‍ണ്ണയമോ ഒരു വ്യക്തിയെക്കുറിച്ചുള്ള അന്തിമ വിധിയോ അല്ല.',
    'about.startTest': 'സ്വതന്ത്രമായി തുടങ്ങുക 40- ചോദ്യം പരീക്ഷ',
    'about.testNote': 'എല്ലാ ഘട്ടത്തിലും ഒരു പുതിയ ചോദ്യം ഉയർത്തപ്പെടുന്നു.',
    'about.safeguard': 'റിക്രൂട്ട്മെന്റ് സുരക്ഷ',
    'about.decision': 'ഒരു വിവര സ്രോതസ്സ് - തൊഴിൽ തീരുമാനം അല്ല',
    'about.decisionText':
      'തൊഴിലുടമകള്‍ ക്രമീകരിച്ച അഭിമുഖങ്ങള്‍, പ്രായോഗിക അനുഭവം, മനുഷ്യരുടെ വിലയിരുത്തല്‍ എന്നിവയിലൂടെ ഫലങ്ങള്‍ കൂട്ടിച്ചേര്‍ക്കേണ്ടതുണ്ട്. ഈ പ്ലാറ്റ്‌ഫോം സ്ഥാനാര്‍ഥികളെ തൊഴിലെടുക്കുകയോ നിരസിക്കുകയോ ചെയ്യുന്നില്ല.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  or: {
    'about.eyebrow': 'ସାବଧାନତାର ସହ ମାପିବା । ପ୍ରସଙ୍ଗ ସହିତ ବର୍ଣ୍ଣନା କରିବା ।',
    'about.title': 'ଜ୍ଞାନଶକ୍ତିର ଏକ ସ୍ପଷ୍ଟ ଦୃଷ୍ଟିଭଙ୍ଗୀ',
    'about.lede':
      'ଏକ ଆବିଷ୍କାର, ସଂଖ୍ୟାଗତ, ବାକ୍ୟ ଏବଂ ସ୍ଥାନୀୟ ତର୍କରେ ଏକ ଅନୁକୂଳ ଆକଳନ ସମ୍ପୂର୍ଣ୍ଣ କରନ୍ତୁ। ଫଳାଫଳଗୁଡ଼ିକ ଏକ ବିଶ୍ୱାସ ପରିସର ସହିତ ଆକଳନଗୁଡ଼ିକ - ଜଣେ ବ୍ୟକ୍ତି ବିଷୟରେ ଏକ ନିଦାନ କିମ୍ବା ଏକ ଅନ୍ତିମ ରାୟ ନୁହେଁ।',
    'about.startTest': 'ମୁକ୍ତ 40ପ୍ରଶ୍ନ ପରୀକ୍ଷଣ',
    'about.testNote': 'ପ୍ରତିଟି ପ୍ରୟାସ ପାଇଁ ଗୋଟିଏ ନୂତନ ସନ୍ତୁଳିତ ପ୍ରଶ୍ନ ସେଟ ଅଙ୍କନ କରାଯାଏ ।',
    'about.safeguard': 'ନିଯୁକ୍ତି ସୁରକ୍ଷା',
    'about.decision': 'ସୂଚନାର ଗୋଟିଏ ଉତ୍ସ – ନିଯୁକ୍ତି ନିଷ୍ପତ୍ତି ନୁହେଁ',
    'about.decisionText':
      'ନିଯୁକ୍ତିଦାତାମାନେ ଢାଞ୍ଚାଗତ ସାକ୍ଷାତକାର, ପ୍ରାସଙ୍ଗିକ ଅଭିଜ୍ଞତା ଏବଂ ମାନବୀୟ ସମୀକ୍ଷା ସହିତ ଫଳାଫଳକୁ ସଂଯୋଜିତ କରିବା ଉଚିତ ।',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  as: {
    'about.eyebrow': 'সতৰ্কতাৰে মাপ লোৱা হৈছে। প্ৰসঙ্গৰ সৈতে ব্যাখ্যা কৰা হৈছে।',
    'about.title': 'মগজুৰ শক্তিৰ বিষয়ে এক সুস্পষ্ট দৃষ্টিভংগী',
    'about.lede':
      'এটা পৰিবৰ্তনশীল মূল্যায়ন সম্পূৰ্ণ কৰক, যিটোত বিমূর্ত, সংখ্যাগত, বাক্যগত আৰু স্থানীয় যুক্তি থাকে। ফলাফলে এটা বিশ্বাসৰ পৰিসীমা সহ আনুমানিক হ\u0027ব - এটা ৰোগৰ সনাক্তকৰণ বা এটা ব্যক্তিৰ বিষয়ে এটা চূড়ান্ত শুনানি নহয়।',
    'about.startTest': 'মুক্ত আৰম্ভ কৰক 40-question টেস্ট',
    'about.testNote': 'প্ৰতিটো প্ৰচেষ্টাত এটা নতুন ভাৰসাম্যপূৰ্ণ প্ৰশ্নৰ সেট আঁকা হয়।',
    'about.safeguard': 'নিয়োগ সুৰক্ষা',
    'about.decision': 'তথ্যৰ এক উৎস - নিযুক্তিৰ সিদ্ধান্ত নহয়',
    'about.decisionText': 'এই প্লেটফৰ্মত প্ৰাৰ্থীসকলক নিযুক্তি দিয়া বা নাকচ কৰা নহয়।',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  ne: {
    'about.eyebrow': 'ध्यान दिएर मापन गरिएको । सन्दर्भसँग व्याख्या गरिएको ।',
    'about.title': 'संज्ञानात्मक बल को एक स्पष्ट दृश्य',
    'about.lede':
      'अमूर्त मार्फत एक अनुकूलन मूल्यांकन पूरा, संख्यात्मक, मौखिक, र स्थानिय तर्क. परिणाम एक विश्वास दायरा संग अनुमान छन् - एक निदान वा एक व्यक्ति बारेमा एक अन्तिम फैसला छैन.',
    'about.startTest': 'स्वतन्त्र सुरु गर्नुहोस् 40प्रश्न परीक्षण',
    'about.testNote': 'प्रत्येक प्रयासका लागि एउटा नयाँ सन्तुलित प्रश्न सेट कोरिन्छ ।',
    'about.safeguard': 'भर्ना सुरक्षा',
    'about.decision': 'सूचना को एक स्रोत - एक नियुक्ति निर्णय छैन',
    'about.decisionText':
      'नियोक्ताहरू संरचनात्मक साक्षात्कार संग परिणाम संयोजन गर्नुपर्छ, सम्बन्धित अनुभव, र मानव समीक्षा. यो प्लेटफर्म रूपमा भाडा वा अस्वीकार उम्मेदवार लेबल छैन.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  si: {
    'about.eyebrow': 'පරිස්සමින් මිනුම් කරල, සන්දර්භය එක්ක පැහැදිලි කරල.',
    'about.title': 'ඥානාත්මක ශක්ති පැහැදිලි දැක්මක්',
    'about.lede':
      'සංකීර්ණ හරහා අනුගත තක්සේරුව සම්පූර්ණ, සංඛ්යාත්මක, වචන, හා අවකාශීය තර්ක. ප්රතිඵල විශ්වාසය පරාසයක් සමග ඇස්තමේන්තු වේ - පුද්ගලයෙකු ගැන රෝග විනිශ්චය හෝ අවසන් තීරණය නොවේ.',
    'about.startTest': 'නිදහස් ආරම්භ කරන්න 40- ප්රශ්නය පරීක්ෂණය',
    'about.testNote': 'සෑම ව්‍යාපෘතියක් සඳහාම නව ව්‍යාපෘති ලේඛනයක් සකස් කරනු ලැබේ.',
    'about.safeguard': 'බඳවා ගැනීමේ ආරක්ෂාව',
    'about.decision': 'එක් තොරතුරු මූලාශ්රය - බඳවා ගැනීමේ තීරණයක් නොවේ',
    'about.decisionText':
      'සේවා යෝජකයන් ව්යුහගත සම්මුඛ සාකච්ඡා සමග ප්රතිඵල ඒකාබද්ධ කළ යුතුය, අදාළ අත්දැකීම්, හා මානව සමාලෝචනය. මෙම වේදිකාව කුලියට හෝ ප්රතික්ෂේප ලෙස අපේක්ෂකයන් ලේබල් කරන්නේ නැහැ.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  id: {
    'about.eyebrow': 'Diukur dengan hati-hati, dijelaskan dengan konteks.',
    'about.title': 'Pemahaman yang lebih jelas tentang kekuatan kognitif',
    'about.lede':
      'Selesaikan penilaian adaptatif melalui penalaran abstrak, numerik, verbal, dan spasial. Hasilnya adalah perkiraan dengan rentang kepercayaan - bukan diagnosis atau putusan akhir tentang seseorang.',
    'about.startTest': 'Mulailah bebas 40-pertanyaan tes',
    'about.testNote': 'Sebuah set pertanyaan seimbang baru ditarik untuk setiap upaya.',
    'about.safeguard': 'Perlindungan rekrutmen',
    'about.decision': 'Satu sumber informasi - bukan keputusan mempekerjakan',
    'about.decisionText':
      'Para penyedia pekerjaan harus menggabungkan hasil wawancara yang terstruktur, pengalaman yang relevan, dan tinjauan manusia.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  ms: {
    'about.eyebrow': 'Diukur dengan teliti, dijelaskan dengan konteks.',
    'about.title': 'Pendapat yang lebih jelas tentang kekuatan kognitif',
    'about.lede':
      'Selesai penilaian adaptatif melalui penalaran abstrak, numerik, bertulis, dan spasial. Hasil adalah perkiraan dengan julat kepercayaan - bukan diagnosis atau keputusan akhir tentang seseorang.',
    'about.startTest': 'Mulakan bebas 40-pertanyaan ujian',
    'about.testNote': 'Set soalan seimbang baru dilukis untuk setiap percubaan.',
    'about.safeguard': 'Pemeriksaan keselamatan',
    'about.decision': 'Satu sumber maklumat - bukan keputusan untuk mempekerjakan',
    'about.decisionText':
      'Pekerja mesti menggabungkan hasil dengan temubual terstruktur, pengalaman yang berkaitan, dan tinjauan manusia. Platform tidak melabelkan calon sebagai mempekerjakan atau menolak.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  vi: {
    'about.eyebrow': 'Đo cẩn thận, giải thích theo ngữ cảnh.',
    'about.title': 'Một cái nhìn rõ ràng hơn về những điểm mạnh nhận thức',
    'about.lede':
      'Hoàn thành một đánh giá thích nghi qua lý luận trừu tượng, số, ngôn ngữ, và không gian. Kết quả là ước tính với một khoảng tin cậy - không phải là chẩn đoán hay phán quyết cuối cùng về một người.',
    'about.startTest': 'Bắt đầu tự do 40- câu hỏi thử nghiệm',
    'about.testNote': 'Một tập hợp câu hỏi cân bằng mới được vẽ cho mỗi nỗ lực.',
    'about.safeguard': 'Bảo vệ tuyển dụng',
    'about.decision': 'Một nguồn thông tin - không phải là quyết định tuyển dụng',
    'about.decisionText':
      'Các nhà tuyển dụng phải kết hợp kết quả với các cuộc phỏng vấn có cấu trúc, kinh nghiệm liên quan, và đánh giá con người.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  th: {
    'about.eyebrow': 'วัดด้วยความระมัดระวัง อธิบายด้วยบริบท',
    'about.title': 'ความเข้มแข็งทางความคิด',
    'about.lede':
      'ทำการประเมินความสามารถในการปรับตัวได้เต็มที่ ผ่านการคิดเชิงนามธรรม ทางสถิติ ทางภาษา และทางพืชศาสตร์ ผลลัพธ์คือการประมาณการด้วยความเชื่อมั่น - ไม่ใช่การวินิจฉัยหรือคำตัดสินสุดท้ายเกี่ยวกับบุคคล',
    'about.startTest': 'เริ่มต้นที่ฟรี 40- คำถามทดสอบ',
    'about.testNote': 'คำถามที่สมดุลใหม่จะถูกวาดขึ้นมาสำหรับทุกครั้งที่พยายาม',
    'about.safeguard': 'ความปลอดภัยในการจ้างงาน',
    'about.decision': 'แหล่งข้อมูลเดียว ไม่ใช่การตัดสินใจจ้างงาน',
    'about.decisionText':
      'เจ้าของงานต้องรวมผลการสัมภาษณ์ ประสบการณ์ที่เกี่ยวข้อง และการตรวจสอบของมนุษย์',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  my: {
    'about.eyebrow': 'သတိထားစွာနဲ့တိုင်းတာ. အကြောင်းအရာနဲ့ရှင်းပြ.',
    'about.title': 'သိမြင်မှုစွမ်းရည်၏ရှင်းလင်းမြင်သာမြင်ကွင်း',
    'about.lede':
      'ကျော် adaptive အကဲဖြတ်မှုပြီးစီး, အရေအတွက်, verbal, နှင့် space အကြောင်းပြချက်. ရလဒ်များကိုယုံကြည်စိတ်ချရမှုအကွာအဝေးနှင့်အတူခန့်မှန်းချက်ဖြစ်ကြသည် - လူတစ်ယောက်အကြောင်းကိုရောဂါရှာဖွေတွေ့ရှိခြင်းသို့မဟုတ်နောက်ဆုံးဆုံးဖြတ်ချက်မဟုတ်.',
    'about.startTest': 'အခမဲ့စတင်ပါ 40-မေးခွန်းစစ်ဆေးခြင်း',
    'about.testNote': 'အသစ်တစ်စုံတစ်ရာမျှတသောမေးခွန်းစုတစ်ခုကိုကြိုးစားမှုတိုင်းအတွက်ဆွဲထားသည်။',
    'about.safeguard': 'ဝန်ထမ်းခေါ်ယူရေးကာကွယ်ရေး',
    'about.decision': 'အချက်အလက်များ၏တစ်ဦးအရင်းအမြစ် - မငှားရမ်းခြင်းဆုံးဖြတ်ချက်',
    'about.decisionText':
      'အလုပ်ရှင်များဖွဲ့စည်းပုံအင်တာဗျူးနှင့်အတူရလဒ်များကိုပေါင်းစပ်ရပါမည်, သက်ဆိုင်သောအတွေ့အကြုံ, နှင့်လူ့ပြန်လည်သုံးသပ်. အဆိုပါ platform ကိုငှားရမ်းသို့မဟုတ်ငြင်းပယ်အဖြစ်ကိုယ်စားလှယ်လောင်းများကို label မထား.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  km: {
    'about.eyebrow': 'វាស់ដោយ​ប្រុងប្រយ័ត្ន \u0026 # 160; ។ ពន្យល់​ដោយ​បរិបទ \u0026 # 160; ។',
    'about.title': 'ទិដ្ឋភាព​ច្បាស់​នៃ​កម្លាំង​នៃ​ការ​យល់ដឹង',
    'about.lede':
      'បញ្ចប់ការវាយតម្លៃដែលសម្រួលលើការគិតបែបអរូបី លេខ ពាក្យ និង ស្ថានីយ៍ ។ លទ្ធផលគឺការប៉ាន់ប្រមាណជាមួយជួរនៃការជឿទុកចិត្ត - មិនជាការវិនិច្ឆ័យឬការសម្រេចចិត្តចុងក្រោយអំពីមនុស្សម្នាក់ ។',
    'about.startTest': 'ចាប់ផ្ដើម​ដោយ​ឥត​គិត​ថ្លៃ 40សំណួរ​សាកល្បង',
    'about.testNote':
      'សំណួរ​ថ្មី​ដែល​បាន​តុល្យភាព​ត្រូវ​បាន​គូរ​សម្រាប់​ការ​ប៉ុនប៉ង​នីមួយៗ \u0026 # 160; ។',
    'about.safeguard': 'ការ​ជ្រើសរើស​ការងារ',
    'about.decision': 'ប្រភពព័ត៌មានមួយ - មិនមែនការសម្រេចចិត្តជួល',
    'about.decisionText':
      'និយោជកត្រូវតែរួមបញ្ចូលគ្នានូវលទ្ធផលជាមួយនឹងការសម្ភាសន៍ដែលមានរចនាសម្ព័ន្ធ, បទពិសោធដែលទាក់ទងនិងពិនិត្យឡើងវិញមនុស្ស. វេទិកានេះមិនដាក់ស្លាកបេក្ខជនជាជួលឬបដិសេធ.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  lo: {
    'about.eyebrow': 'ວັດແທກດ້ວຍຄວາມລະມັດລະວັງ. ອະທິບາຍດ້ວຍສະພາບແວດລ້ອມ.',
    'about.title': 'ເບິ່ງ​ຄວາມ​ເຂັ້ມແຂງ​ຂອງ​ການ​ຮັບ​ຮູ້​ຢ່າງ​ຈະ​ແຈ້ງ​ຂຶ້ນ',
    'about.lede':
      'ສໍາເລັດການທົບທວນຄືນທີ່ປັບຕົວໄດ້ຜ່ານການຄິດໄລ່ແບບສະຖິຕິ, ຕົວເລກ, ພາສາ, ແລະພື້ນທີ່. ຜົນໄດ້ຮັບແມ່ນການຄາດຄະເນທີ່ມີຂອບເຂດຄວາມໄວ້ວາງໃຈ - ບໍ່ແມ່ນການວິນິດໄສຫຼືການຕັດສິນໃຈສຸດທ້າຍກ່ຽວກັບຄົນ.',
    'about.startTest': 'ເລີ່ມຕົ້ນ​ຟຣີ 40ສອບຖາມ',
    'about.testNote': 'ຊຸດ​ຄຳຖາມ​ທີ່​ສົມດຸນ​ໃໝ່​ຈະ​ຖືກ​ຂຽນ​ຂຶ້ນ​ສຳລັບ​ການ​ພະຍາຍາມ​ທຸກໆ​ຄັ້ງ.',
    'about.safeguard': 'ຄວາມປອດໄພ',
    'about.decision': 'ຂໍ້ມູນຈາກແຫຼ່ງຂໍ້ມູນດຽວ - ບໍ່ແມ່ນການຕັດສິນໃຈຈ້າງງານ',
    'about.decisionText':
      'ຜູ້ຈ້າງງານຕ້ອງລວມເອົາຜົນໄດ້ຮັບທີ່ມີການສໍາພາດທີ່ມີໂຄງສ້າງ, ປະສົບການທີ່ກ່ຽວຂ້ອງ, ແລະການທົບທວນຄືນຂອງມະນຸດ. ເວທີບໍ່ຕິດស្លាກຜູ້ສະ ໝັກ ວ່າຈ້າງຫຼືປະຕິເສດ.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  tl: {
    'about.eyebrow': 'Sinusukat ng maingat. Ipinaliwanag sa konteksto.',
    'about.title': 'Isang mas malinaw na view ng kognitibo lakas',
    'about.lede':
      'Kumpletuhin ang isang adaptive na pagsusuri sa kabuuan ng mahirap unawain, de-numerong, verbal, at spatial na pangangatwiran. Ang mga resulta ay mga pagtatantya na may isang hanay ng tiwala - hindi isang diyagnosis o isang huling pasiya tungkol sa isang tao.',
    'about.startTest': 'Simulan ang libreng 40-tanong pagsubok',
    'about.testNote':
      'Ang isang bagong balanseng tanong set ay inilabas para sa bawat pagtatangka.',
    'about.safeguard': 'Recruitment proteksyon',
    'about.decision': 'Isang pinagmulan ng impormasyon - hindi isang desisyon sa pagpapaupa',
    'about.decisionText':
      'Ang mga employer ay dapat na pagsamahin ang mga resulta sa naka-istrakturang mga panayam, may-katuturang karanasan, at mga review ng tao.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  jv: {
    'about.eyebrow': 'Diukur kanthi ati-ati. Dijelasaké kanthi konteks.',
    'about.title': 'Akèh kang bisa digawé saka komposisi iki.',
    'about.lede':
      'Ngrampungaké evaluasi adaptatif liwat penalaran abstrak, numerik, verbal, lan spasial. Hasilé minangka estimasi kanthi interval kepercayaan - ora diagnosa utawa verdict pungkasan babagan wong.',
    'about.startTest': 'Diwiwiti saka 40-question test',
    'about.testNote': 'Saben wangun gawéan iku kudu digawé kanthi cara sing bener.',
    'about.safeguard': 'Rekrutmen',
    'about.decision': 'Satunggaling sumber informasi - ora dados kaputusan pagawéan',
    'about.decisionText':
      'Pagawé kudu nggabungake asil karo wawancara struktural, pengalaman sing relevan, lan tinjauan manungsa. Platform ora label calon minangka upah utawa nolak.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  su: {
    'about.eyebrow': 'Diukur kanthi ati-ati. Dijelaskeun nganggo konteks.',
    'about.title': 'A luwih jelas tampilan saka kekuatan kognitif',
    'about.lede':
      'Selesaikeun evaluasi adaptatif ngaliwatan penalaran abstrak, numerik, verbal, sarta spasial. Hasilna nyaéta perkiraan kalayan jangkungna percaya - lain diagnosa atawa verdict panungtungan ngeunaan jalma.',
    'about.startTest': 'Mulai bebas 40-question test',
    'about.testNote': 'Saben wangun wangun anyar diwiwiti kanthi wangun anyar.',
    'about.safeguard': 'Rekrutmen',
    'about.decision': 'Salah siji sumber informasi - ora keputusan kanggo nyewa',
    'about.decisionText':
      'Pagawé kudu ngagabungkeun hasil jeung wawancara struktural, pangalaman relevan, sarta tinjauan manusa. Platform teu label calon salaku pagawean atawa nolak.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  ar: {
    'about.eyebrow': 'قياس بعناية، شرح في السياق.',
    'about.title': 'رؤية أوضح لمواطن القوة المعرفية',
    'about.lede':
      '2- إكمال تقييم تكيفي عبر التفكير المجرد والرقمي واللفظي والمكاني. والنتائج هي تقديرات مع نطاق ثقة ــ وليس تشخيصاً أو حكماً نهائياً بشأن شخص ما.',
    'about.startTest': 'هيا بنا 40-اختبار السؤال',
    'about.testNote': 'وتسحب مجموعة أسئلة متوازنة جديدة لكل محاولة.',
    'about.safeguard': 'ضمانة التوظيف',
    'about.decision': 'مصدر واحد للمعلومات - لا قرار توظيف',
    'about.decisionText':
      'ويتعين على أرباب العمل أن يجمعوا بين النتائج والمقابلات المنظمة، والخبرة ذات الصلة، والمراجعة البشرية. ولا تضع المنصة علامات على المرشحين باعتبارهم مستأجرين أو مرفوضين.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  fa: {
    'about.eyebrow': 'با دقت اندازه گيري شده و با متن توضيح داده شده',
    'about.title': 'يک نگاه روشن تر به نيروهاي شناختي',
    'about.lede':
      'یک ارزیابی سازگار را در طول استدلال انتزاعی، عددی، کلامی و فضایی تکمیل کنید. نتایج تخمین‌هایی با یک محدوده اطمینان هستند - نه یک تشخیص یا حکم نهایی درباره یک شخص.',
    'about.startTest': 'شروع به آزادي کنيد 40- آزمون سوال',
    'about.testNote': 'یک مجموعهٔ متوازن از سوالات برای هر تلاش کشیده می‌شود.',
    'about.safeguard': '. يه جور محافظت از استخدام',
    'about.decision': 'يه منبع اطلاعات - نه يه تصميم استخدامي',
    'about.decisionText':
      'کارفرمایان باید نتایج را با مصاحبه‌های ساختاری، تجربه مرتبط و بررسی انسانی ترکیب کنند.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  tr: {
    'about.eyebrow': 'Dikkatle ölçülmüş, bağlamla açıklanmış.',
    'about.title': 'Bilişsel güçler hakkında daha net bir bakış',
    'about.lede':
      'Soyut, sayısal, sözel ve uzamsal mantık üzerinde adaptif bir değerlendirme tamamlayın. Sonuçlar güven aralığı ile tahminlerdir - bir kişi hakkında bir teşhis veya nihai bir karar değil.',
    'about.startTest': 'Özgürlüğü başlat 40- Soru testi',
    'about.testNote': 'Her deneme için yeni bir dengeli soru seti çizilir.',
    'about.safeguard': 'İşe alım güvencesi',
    'about.decision': 'Tek bir bilgi kaynağı - işe alma kararı değil',
    'about.decisionText':
      'İşverenler sonuçları yapısal görüşmeler, ilgili deneyim ve insan gözden geçirmeleriyle birleştirmeli. platform adayları işe almak veya reddetme olarak etiketlemez.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  he: {
    'about.eyebrow': 'מודדים בזהירות, מסבירים בהקשר.',
    'about.title': 'תמונה ברורה יותר של חזקות קוגניטיביות',
    'about.lede':
      'השלים הערכה התאמה על פני חשיבה מופשטת, מספרית, מילולית ומרחבית. התוצאות הן הערכות עם טווח אמון - לא אבחנה או פסק דין סופי על אדם.',
    'about.startTest': 'התחל את המשחק החופשי 40-מבחן שאלות',
    'about.testNote': 'קבוצת שאלות מאוזנת חדשה נלקחת עבור כל ניסיון.',
    'about.safeguard': 'הגנה על גיוס',
    'about.decision': 'מקור מידע אחד - לא החלטה של שכר',
    'about.decisionText':
      'המעסיקים חייבים לשלב את התוצאות עם ראיון מבוקר, ניסיון רלוונטי, וסקירה אנושית. הפלטפורמה לא מזהה מועמדים כמשרתים או נדחים.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  ku: {
    'about.eyebrow': 'بە وردی پێوانە کراوە، بە شێوەی بەستێن ڕوون کراوە.',
    'about.title': 'بینینێکی ڕوونتر لە توانای بیرکردنەوە',
    'about.lede':
      'بەدواداچوونێکی گونجاوی تەواو بکە لە ڕێگەی بیرکردنەوەیەکی نەبینراو، ژمارەیی، وشەییەوە، و بۆشایی. ئەنجامەکان بە بڕوای بڕواپێکراون - نە پشکنین یان بڕیاری کۆتایی دەربارەی کەسێک.',
    'about.startTest': 'دەست پێکردنی ئازاد 40تاقیکردنەوە',
    'about.testNote': 'بۆ هەر هەوڵێک پرسیارێکی نوێی هاوسەنگی دروست دەکرێت.',
    'about.safeguard': 'پارێزەری کۆکردنەوەی',
    'about.decision': 'سەرچاوەی زانیارییەک - بڕیارێکی کارپێکردن نیە',
    'about.decisionText':
      'کاربەدەستەکان دەبێت ئەنجامەکان بە چاوپێکەوتنی رێکخراو، ئەزموونێکی پەیوەندیدار و پشکنینی مرۆڤەکان ببەستنەوە. پڕۆگرامەکە ناتوانێت کاندیدەکان وەک کاربکەن یان ڕەت بکەنەوە.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  uz: {
    'about.eyebrow': 'Буни тушуниш учун, вазиятга қараб тушунтирилган.',
    'about.title': 'Когнитив кучларнинг аниқроқ кўриниши',
    'about.lede':
      'Абстракт, рақамли, сўзли ва пространствений фикрлашни тўлиқ ўрганиш. Натижалар ишончли диапазони билан баҳоланади - бу диагноз ёки шахс ҳақидаги якуний ҳукм эмас.',
    'about.startTest': 'Оқ 40_Сўров',
    'about.testNote': 'Ҳар бир уриниш учун янги саволлар тўплами чизилади.',
    'about.safeguard': 'Ишга олишни ҳимоялаш',
    'about.decision': 'Биргина маълумот манбаси - ишга олиш қарори эмас',
    'about.decisionText':
      'Иш берувчилар натижаларни тузилган суҳбатлар, тегишли тажрибага ва инсоний кўриб чиқиш билан бирлаштириши керак. Платформа номзодларни ишга олиш ёки рад этиш деб белгиламайди.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  kk: {
    'about.eyebrow': 'Қамқорлықпен өлшенген. Контекстпен түсіндірілген.',
    'about.title': 'Когнитивті күш-қуат туралы түсінік',
    'about.lede':
      'Абстрактілі, сандық, сөздік және кеңістіктік ойлау қабілеттерін бағалау. Нәтижелер сенімділік шегі бойынша болжамдар, бірақ диагноз немесе адамға қатысты соңғы шешім емес.',
    'about.startTest': 'Тегін бастау 40- question test',
    'about.testNote': 'Әрбір әрекет үшін жаңа теңдестірілген сұрақтар жиынтығы сызылады.',
    'about.safeguard': 'Қабылдау',
    'about.decision': 'Бір ғана ақпарат көзі - жұмысқа қабылдау шешімі емес',
    'about.decisionText':
      'Жұмыс берушілердің бұл нәтижелерді құрылымдық сұхбаттар, тәжірибе және адами талдаумен біріктіруі керек. Платформа үміткерлерді жұмысқа қабылдау немесе қабылдамау туралы шешім қабылдамайды.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  az: {
    'about.eyebrow': 'Dəqiq ölçülmüş, kontekstlə izah edilmiş.',
    'about.title': 'Kognitiv güclərin daha aydın görünüşü',
    'about.lede':
      'Abstrakt, rəqəmsal, sözlü və məkanik fikirləşmə üzərində uyğunlaşma qiymətləndirməsini tamamlayın. Nəticələr etibar diapazonu ilə təxminlərdir - bir şəxs haqqında diaqnoz və ya son qərar deyil.',
    'about.startTest': 'Free 40-question test',
    'about.testNote': 'Hər bir cəhd üçün yeni balanslaşdırılmış suallar toplusu çəkilir.',
    'about.safeguard': 'Təhlükəsizlik',
    'about.decision': 'Bir məlumat mənbəyi - işə qəbul qərarı deyil',
    'about.decisionText':
      'İşverənlər strukturlaşdırılmış müsahibələr, əlaqəli təcrübə və insan təhlilləri ilə nəticələri birləşdirməlidir. Platforma namizədləri işə götürmə və ya rədd etmə kimi etiketləməməlidir.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  ps: {
    'about.eyebrow': 'د پاملرنې سره اندازه. د شرایطو سره تشریح.',
    'about.title': 'د پوهنیزو قوتونو یو روښانه نظر',
    'about.lede':
      'د خلاص، عددي، لفظي، او فضايي استدلال په اوږدو کې د تطبیق وړ ارزونه بشپړه کړئ. پایلې د اعتماد د حد سره اټکلونه دي - نه د تشخیص یا د یو کس په اړه د وروستي حکم.',
    'about.startTest': 'د آزادي پیل کول 40- پوښتنه ازموينه',
    'about.testNote': 'د هرې هڅې لپاره د نوي متوازن پوښتنې سیټ راټول شوی.',
    'about.safeguard': 'د استخدام ساتنه',
    'about.decision': 'د معلوماتو یو سرچینه - نه د استخدام پریکړه',
    'about.decisionText':
      'کارګران باید د جوړښتونو مرکو، اړونده تجربو او انساني کتنې سره پایلې ترکیب کړي. د پلیټ فارم نوماندان د کار یا ردولو په توګه لیبل نه کوي.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  tk: {
    'about.eyebrow': 'Ýörite ölçeýjiler.',
    'about.title': 'A clearer view of cognitive strengths',
    'about.lede':
      'Tersine, abstrakt, sanly, sözli we ýerleýin düşünjeler arkaly bir adaptiw baha bermegi tamamla. Netijeler bir ynam aralygy bilen hasaplamalar - bir adam barada bir diagnoz ýa-da bir soňky karar däl.',
    'about.startTest': 'Başla 40_Sorag',
    'about.testNote': 'Her bir synag üçin täze bir deňagramly sorag düzüw çyzylýar.',
    'about.safeguard': 'Recruitment safeguard',
    'about.decision': 'Bir maglumat çeşmesi - işe almak karary däl',
    'about.decisionText':
      'Iş berijiler netijeleri gurallary bilen söhbetdeşlik, degişli tejribe we adam gözden geçirmegi bilen birleşdirmeli. Platforma dalaşgärleri işe almak ýa-da ret etmek üçin etiketlemeýär.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  tg: {
    'about.eyebrow': 'Бо эҳтиёт чен карда шуд. Бо контекст шарҳ дода шуд.',
    'about.title': 'Тасвири равшантар аз қувваҳои маърифатӣ',
    'about.lede':
      'Таҳқиқоти мутобиқшавандаро дар бораи ақидаи абстрактӣ, рақамӣ, калимаӣ ва фазоӣ ба итмом расонед. Натиҷаҳо бо диапазони боварӣ ҳисоб карда мешаванд - на ташхис ё ҳукми ниҳоӣ дар бораи шахс.',
    'about.startTest': 'Оғози озод 40- question test',
    'about.testNote': 'Барои ҳар як кӯшиш як маҷмӯи саволҳои нав кашида мешавад.',
    'about.safeguard': '\u0026 Нигоҳ доштан',
    'about.decision': 'Як манбаи иттилоот - на як қарор дар бораи кор',
    'about.decisionText':
      'Корфармоён бояд натиҷаҳоро бо мусоҳибаҳои сохторӣ, таҷрибаи дахлдор ва баррасии инсонӣ якҷоя кунанд. Платформа номзадҳоро ҳамчун кор ё рад кардан нишон намедиҳад.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  sw: {
    'about.eyebrow': 'Kipimo kwa makini. Explained na mazingira.',
    'about.title': 'mtazamo wazi wa nguvu za utambuzi',
    'about.lede':
      'Kukamilisha tathmini adaptive katika abstract, kihesabu, kisemakweli, na hoja nafasi. Matokeo ni makadirio na aina ya uhakika - si utambuzi au hukumu ya mwisho kuhusu mtu.',
    'about.startTest': 'Kuanza bure 40-swali mtihani',
    'about.testNote': 'Mfano wa dhana ya utaratibu ni mchakato wa kutafuta kila kitu.',
    'about.safeguard': 'Uhamiaji ulinzi',
    'about.decision': 'Moja chanzo cha habari - si uamuzi wa kuajiri',
    'about.decisionText':
      'Waajiri lazima kuchanganya matokeo na mahojiano muundo, uzoefu muhimu, na tathmini ya binadamu. jukwaa haina label wagombea kama kulipa au kukataa.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  ha: {
    'about.eyebrow': 'An ƙaddara shi da hankali.',
    'about.title': 'A bayyanar da gani na cognitive ƙarfi',
    'about.lede': '@ action',
    'about.startTest': 'Fara 40QShortcut',
    'about.testNote': 'An yi wani sabon tsari na tambaya mai daidaituwa ga kowace kokarin.',
    'about.safeguard': 'Tsarin aiki',
    'about.decision': '@ info: status',
    'about.decisionText':
      'Masu aiki dole ne su haɗa sakamakon da tattaunawa mai tsari, da ƙwarewa mai dangantaka, da kuma nazarin mutum.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  am: {
    'about.eyebrow': 'በጥንቃቄ የተወሰደ፣ በቅደም ተከተል የተብራራ ነው።',
    'about.title': 'የዕውቀት ችሎታዎችን ግልጽ የሆነ እይታ',
    'about.lede':
      'በግልጽ፣ በቁጥር፣ በቃል እና በስፋት ምክንያት ላይ የተመቻቸ ትንተናን ሙሉ። ውጤቶቹ በጥብቅነት ክልል ውስጥ ያሉት ትንተናዎች ናቸው - ስለ ሰው መከታተል ወይም የመጨረሻ ውሳኔ አይደለም።',
    'about.startTest': 'ነጻ 40ጥያቄ',
    'about.testNote': 'አዲስ የተመጣጠነ ጥያቄ ስብስብ ለእያንዳንዱ ሙከራ ይቀመጣል',
    'about.safeguard': 'የሥራ ማስፈጸሚያ',
    'about.decision': 'አንድ መረጃ ምንጭ - የሥራ ስምሪት ውሳኔ አይደለም',
    'about.decisionText':
      'የሥራ አጥነት መቀነስን ለመቀነስ የሥራ አጥነት መቀነስን ለመቀነስ የሥራ አጥነት መቀነስን ለመቀነስ የሥራ አጥነት መቀነስን ለመቀነስ',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  yo: {
    'about.eyebrow': 'Tí a fi àwọn ìṣàmúlò-ètò pamọ́.',
    'about.title': 'Àwọn ìṣàfihàn tí a fi hàn àwọn ìmọ̀ràn',
    'about.lede':
      'Ṣí ìṣàmúlò-ètò ìṣàfihàn nínú àwọn ìṣàfihàn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn àwọn à',
    'about.startTest': 'Ṣí àwọn àwọn àwọn àwọn àwọn àwọn 40-question test',
    'about.testNote':
      'Àtòjọ àwọn ààyè-iṣẹ́ tuntun tí a tí ìdáràn nípa ìyànṣẹ̀ fún ìyànṣẹ̀ fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún fún',
    'about.safeguard': 'Àwọn Ìṣàmúlò-ètò',
    'about.decision': 'Àwọn Àkọlé àwòrán',
    'about.decisionText':
      'Awọn oludari gbọdọ ṣe iṣọkan awọn abajade pẹlu awọn ibaraẹnisọrọ ti a ṣe apẹrẹ, iriri ti o ni ibatan, ati atunyẹwo eniyan. Platform ko ṣe ayẹwo awọn oludije bi awọn iṣẹ tabi awọn ipadabọ.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  ig: {
    'about.eyebrow': 'E mepụtara ya n\u0027ụzọ ziri ezi. E kọwaara ya na ngwe.',
    'about.title': 'A clearer view nke cognitive strengths',
    'about.lede':
      'Mepụta nnyocha na-adaba n\u0027ime ihe na-apụtaghị n\u0027ihu, ọnụọgụgụ, okwu, nakwa nghọta dị n\u0027ime. Ihe a na-ahụ bụ nnyocha na-adabere n\u0027ihe - ọ bụghị nchọpụta ma ọ bụ nghọta nke ikpeazụ banyere onye ahụ.',
    'about.startTest': 'Bido n\u0027efu 40-question test',
    'about.testNote': 'A na-edepụta nsetajụ ọfụụ maka nrụnye ọbụla.',
    'about.safeguard': 'Nhazi',
    'about.decision': 'Otu isi mmalite ozi - ọ bụghị nghọtahie ịrụ ọrụ',
    'about.decisionText':
      'Ndị ọrụ ga-agbakwunye nsonaazụ na nnyocha na-arụ ọrụ, ahụmịhe dị mkpa, na nyocha mmadụ. Platform anaghị egosi ndị ọbịa dịka ọrụ ma ọ bụ kwụsị.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  om: {
    'about.eyebrow':
      'Akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas, akkasumas,',
    'about.title': 'Seenaa gaariin haala gaariin',
    'about.lede':
      'Akkasumas, kan itti fufuu fi kan itti fufuu, kan itti fufuu fi kan itti fufuu, kan itti fufuu fi kan itti fufuu, kan itti fufuu fi kan itti fufuu, kan itti fufuu fi kan itti fufuu, kan itti fufuu fi kan itti fufuu, kan itti fufuu fi kan itti fufuu, kan itti fufuu fi kan itti fufuu, kan itti fufuu fi kan itti fufuu, kan itti fufuu fi kan itti fufuu, kan itti fufuu fi kan itti fufu.',
    'about.startTest': 'Jijjiirama 40-question test',
    'about.testNote':
      'Seera-qe\u0027ee haaraan wal-fakkaatu kan galmeessama ta\u0027e kan galmee tokko tokkoof.',
    'about.safeguard': 'Akkuma',
    'about.decision': 'Fuula tokko - hin ta\u0027in murtii hojiirra oolchuu',
    'about.decisionText':
      'Akkasumas, hojiin kun akka hojiin hojiirra oolchuu, hojiirra oolchuu, fi hojiirra oolchuu kan nama ta\u0027e ta\u0027uu qaba.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  so: {
    'about.eyebrow': 'La miisaamiyey si taxadar leh.',
    'about.title': 'A aragti cad oo xoogga aqooneed',
    'about.lede':
      'Dhameystirka qiimeyn ku habboon oo dhan xaddidan, tirakoobka, hadalka, iyo sababaynta dhulka. Natiijooyinka waa tirakoobyo la xawaare kalsooni - ma aha cabirka ama go\u0027aan kama dambaysta ah oo ku saabsan qof.',
    'about.startTest': 'Bilawga bilaash ah 40- su\u0027aal imtixaan',
    'about.testNote': 'A su\u0027aal cusub oo miisaan leh ayaa loo soo saaray isku day kasta.',
    'about.safeguard': 'Ilaalinta shaqaaleysiinta',
    'about.decision': 'Mid ka mid ah xogta - ma aha go\u0027aan shaqo raadin',
    'about.decisionText':
      'Eegista waa in ay isku daraan natiijooyinka la wareysi qaabaysan, khibrad la xiriirta, iyo dib u eegista aadanaha. Platform ma leh murashaxiinta sida mushahar ama diido.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  zu: {
    'about.eyebrow': 'Ilinganiselwe ngokucophelela. Icaciswe ngesimo.',
    'about.title': 'Umbono ocacile wekhono lokucabanga',
    'about.lede':
      'Ukufakazela ukulinganiselwa okuhambisanayo phakathi kokungabaza, okungokwenani, okubhalwe ngamagama, nokucabanga okungaphakathi. Iziphetho ziyimibiko enezinga lokuthembela - hhayi ukuhlolwa noma isiphetho esiphelele mayelana nomuntu.',
    'about.startTest': 'Qala i-free 40-question test',
    'about.testNote': 'Imibuzo emisha elinganiselwe iqoqwa ngazo zonke iziphakamiso.',
    'about.safeguard': 'Ukuvikelwa komsebenzi',
    'about.decision': 'Umthombo owodwa wolwazi - hhayi isigqibo sokuqasha',
    'about.decisionText':
      'Abaqashi kumele bahlanganise izimpendulo nezingqungquthela ezilungisiwe, ikhono elifanele, kanye nokuhlolwa komuntu. I-platform ayiphawuli abaqashi njengemisebenzi noma ukuxoshwa.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  xh: {
    'about.eyebrow': 'Ilinganiselwe ngokucothayo. Icaciswe ngemeko.',
    'about.title': 'Umbono ocacileyo wobuchule bokuqonda',
    'about.lede':
      'Ugqibezela uvavanyo olulungelelanisiweyo olubandakanya ukuqonda okubonakalayo, okunomanani, okubhaliweyo, kunye nokuqonda okunobubanzi. Iimpumelelo zii-estimates ezine-confidence range - hayi uvavanyo lwezifo okanye uvavanyo olugqibeleleyo malunga nomntu.',
    'about.startTest': 'Qala i- 40-question test',
    'about.testNote': 'Iqela elitsha elizinzileyo lemibuzo lizotywa ngazo zonke iziganeko.',
    'about.safeguard': 'Ukhuseleko lokuqeshwa',
    'about.decision': 'Ulwazi olulodwa - hayi isigqibo sokuba',
    'about.decisionText':
      'Abaqeshi kufuneka badibanisa iziphumo neencoko ezicwangcisiweyo, iimvakalelo ezifanelekileyo, kunye nohlolo lwabantu. Inkqubo ayiphawuli abakhethiweyo njengemisebenzi okanye ukuyeka.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  sn: {
    'about.eyebrow': 'Kuongororwa nechikonzero. Kuratidzwa nechikonzero.',
    'about.title': 'A yakajeka pfungwa yekuziva simba',
    'about.lede':
      'Kuzadza adaptive kuongorora pamusoro abstract, numerical, verbal, uye spatial pfungwa. Zvibodzwa zvinofungidzirwa ne confidence range - kwete chirwere kana chizere mashoko pamusoro munhu.',
    'about.startTest': 'Kutanga 40-question test',
    'about.testNote': 'A nyowani yakaenzana mibvunzo seti inogadzirwa kune yega yega kuedza.',
    'about.safeguard': 'Kuchengetedzwa kwevashandi',
    'about.decision': 'Mumwe mutengesi wezvemari - kwete mutengesi wezvemari',
    'about.decisionText':
      'Va employers vanofanira kubatanidza zvibodzwa neyakavakirwa kusangana, zvinokosha ruzivo, uye munhu kuongorora. The platform haasi kuumba vavhoti sekugara kana kubvisa.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  ln: {
    'about.eyebrow': 'Mesuré avec soin. Expliqué avec contexte.',
    'about.title': 'Une vision plus claire des forces cognitives',
    'about.lede':
      'Compléter une évaluation adaptative à travers le raisonnement abstrait, numérique, verbal et spatial.Les résultats sont des estimations avec un intervalle de confiance - pas un diagnostic ou un verdict final sur une personne.',
    'about.startTest': 'Start the free 40-question test',
    'about.testNote': 'Un nouveau jeu de questions équilibré est tiré pour chaque tentative.',
    'about.safeguard': 'Recruitment safeguard',
    'about.decision': 'Osolo fonte de informação - não uma decisão de contratação',
    'about.decisionText':
      'Embi na-ekombola na-ekombola na-ekombola na-ekombola na-ekombola na-ekombola na-ekombola na-ekombola na-ekombola na-ekombola na-ekombola na-ekombola na-ekombola na-ekombola na-ekombola na-ekombola na-ekombola na-ekombola.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
  rw: {
    'about.eyebrow': 'Na:. Na: Imvugiro.',
    'about.title': 'A Reba Bya',
    'about.lede':
      'A, Binyuranye,, na. Na: A Urutonde - OYA A Cyangwa A Iheruka Bigyanye A Umukoresha.',
    'about.startTest': 'i 40- Igerageza',
    'about.testNote': 'A Gishya Ikibazo Gushyiraho ni ya: buri.',
    'about.safeguard': 'Gucunga',
    'about.decision': 'Inkomoko Bya Ibisobanuro: - OYA A',
    'about.decisionText':
      'Gukomatanya Ibisubizo Na:, Igihe, na Umunyamuntu Isuzuma. OYA Akarango Nka Cyangwa.',
    'common.home': '',
    'common.iqGuides': '',
    'common.about': '',
    'common.startTest': '',
  },
};
